import { defineComponent as _t, ref as xe, onMounted as po, onUnmounted as ho, computed as cr, watch as ur, openBlock as $t, createElementBlock as St, createElementVNode as Ke, normalizeClass as vo, withDirectives as mo, vShow as yo, renderSlot as gr, withModifiers as Ze } from "vue";
var wr = (n, i, o) => {
  if (!i.has(n))
    throw TypeError("Cannot " + o);
}, go = (n, i, o) => (wr(n, i, "read from private field"), o ? o.call(n) : i.get(n)), wo = (n, i, o) => {
  if (i.has(n))
    throw TypeError("Cannot add the same private member more than once");
  i instanceof WeakSet ? i.add(n) : i.set(n, o);
}, bo = (n, i, o, u) => (wr(n, i, "write to private field"), u ? u.call(n, o) : i.set(n, o), o);
const lr = [
  "aztec",
  "code_128",
  "code_39",
  "code_93",
  "codabar",
  "data_matrix",
  "ean_13",
  "ean_8",
  "itf",
  "pdf417",
  "qr_code",
  "upc_a",
  "upc_e",
  "unknown"
];
function Co(n) {
  if (br(n))
    return {
      width: n.naturalWidth,
      height: n.naturalHeight
    };
  if (_o(n))
    return {
      width: n.width.baseVal.value,
      height: n.height.baseVal.value
    };
  if (Cr(n))
    return {
      width: n.videoWidth,
      height: n.videoHeight
    };
  if (_r(n))
    return {
      width: n.width,
      height: n.height
    };
  if ($r(n))
    return {
      width: n.width,
      height: n.height
    };
  if ($o(n))
    return {
      width: n.width,
      height: n.height
    };
  if (So(n))
    return {
      width: n.displayWidth,
      height: n.displayHeight
    };
  throw new Error("Unsupported image type");
}
function br(n) {
  try {
    return n instanceof HTMLImageElement;
  } catch {
    return !1;
  }
}
function _o(n) {
  try {
    return n instanceof SVGImageElement;
  } catch {
    return !1;
  }
}
function Cr(n) {
  try {
    return n instanceof HTMLVideoElement;
  } catch {
    return !1;
  }
}
function _r(n) {
  try {
    return n instanceof HTMLCanvasElement;
  } catch {
    return !1;
  }
}
function $r(n) {
  try {
    return n instanceof ImageBitmap;
  } catch {
    return !1;
  }
}
function $o(n) {
  try {
    return n instanceof OffscreenCanvas;
  } catch {
    return !1;
  }
}
function So(n) {
  try {
    return n instanceof VideoFrame;
  } catch {
    return !1;
  }
}
function Po(n) {
  try {
    return n instanceof Blob;
  } catch {
    return !1;
  }
}
function To(n) {
  try {
    return n instanceof ImageData;
  } catch {
    return !1;
  }
}
function Eo(n, i) {
  try {
    const o = new OffscreenCanvas(n, i);
    if (o.getContext("2d") instanceof OffscreenCanvasRenderingContext2D)
      return o;
    throw new Error("OffscreenCanvasRenderingContext2D is not supported");
  } catch {
    const o = document.createElement("canvas");
    return o.width = n, o.height = i, o;
  }
}
async function Sr(n) {
  if (br(n) && !await Ao(n))
    throw new DOMException("Failed to decode the image.", "InvalidStateError");
  if (Cr(n) && (n.readyState === 0 || n.readyState === 1))
    throw new DOMException(
      "The video data is not available.",
      "InvalidStateError"
    );
  if ($r(n) && Ro(n))
    throw new DOMException("The image bitmap is closed.", "InvalidStateError");
  const { width: i, height: o } = Co(n);
  if (i === 0 || o === 0)
    return null;
  const u = Eo(i, o), d = u.getContext("2d");
  d.drawImage(n, 0, 0);
  const p = d.getImageData(0, 0, i, o);
  return _r(u) && u.remove(), p;
}
async function Oo(n) {
  let i;
  try {
    i = await createImageBitmap(n);
  } catch (o) {
    throw o;
  }
  return await Sr(i);
}
async function Mo(n) {
  if (Po(n))
    return await Oo(n);
  if (To(n)) {
    if (Do(n.data.buffer))
      throw new DOMException(
        "The corresponding array buffer is detached.",
        "InvalidStateError"
      );
    return n;
  }
  return await Sr(n);
}
async function Ao(n) {
  try {
    return await n.decode(), !0;
  } catch {
    return !1;
  }
}
function Do(n) {
  return n.byteLength === 0;
}
function Ro(n) {
  return n.width === 0 && n.height === 0;
}
const fr = (n) => {
  let i;
  const o = /* @__PURE__ */ new Set(), u = (v, b) => {
    const $ = typeof v == "function" ? v(i) : v;
    if (!Object.is($, i)) {
      const y = i;
      i = b ?? typeof $ != "object" ? $ : Object.assign({}, i, $), o.forEach((_) => _(i, y));
    }
  }, d = () => i, p = { setState: u, getState: d, subscribe: (v) => (o.add(v), () => o.delete(v)), destroy: () => {
    o.clear();
  } };
  return i = n(u, d, p), p;
}, xo = (n) => n ? fr(n) : fr, ko = {
  locateFile: (n, i) => {
    var o;
    const u = (o = n.match(new RegExp("(?<=_).+?(?=\\.wasm$)"))) == null ? void 0 : o[0];
    return u ? `https://cdn.jsdelivr.net/npm/@sec-ant/zxing-wasm@2.1.2/dist/${u}/${n}` : i + n;
  }
}, $e = xo()(() => ({
  zxingModuleWeakMap: /* @__PURE__ */ new WeakMap(),
  zxingModuleOverrides: ko
}));
function Fi(n) {
  $e.setState({
    zxingModuleOverrides: n
  });
}
function Pr(n, i = $e.getState().zxingModuleOverrides) {
  const { zxingModuleWeakMap: o } = $e.getState(), u = o.get(
    n
  );
  if (u && Object.is(i, $e.getState().zxingModuleOverrides))
    return u;
  {
    $e.setState({
      zxingModuleOverrides: i
    });
    const d = n(i);
    return o.set(n, d), d;
  }
}
const dr = [
  "Aztec",
  "Codabar",
  "Code128",
  "Code39",
  "Code93",
  "DataBar",
  "DataBarExpanded",
  "DataMatrix",
  "EAN-13",
  "EAN-8",
  "ITF",
  "Linear-Codes",
  "Matrix-Codes",
  "MaxiCode",
  "MicroQRCode",
  "None",
  "PDF417",
  "QRCode",
  "UPC-A",
  "UPC-E"
], fe = {
  tryHarder: !0,
  formats: [],
  maxSymbols: 255
};
async function Fo(n, {
  tryHarder: i = fe.tryHarder,
  formats: o = fe.formats,
  maxSymbols: u = fe.maxSymbols
} = fe, d) {
  const p = await Pr(
    d,
    $e.getState().zxingModuleOverrides
  ), {
    data: v,
    width: b,
    height: $,
    data: { byteLength: y }
  } = n, _ = p._malloc(y);
  p.HEAP8.set(v, _);
  const P = p.readBarcodesFromPixmap(
    _,
    b,
    $,
    i,
    Uo(o),
    u
  );
  p._free(_);
  const w = [];
  for (let M = 0; M < P.size(); ++M) {
    const A = P.get(M);
    w.push({
      ...A,
      format: jo(A.format)
    });
  }
  return w;
}
function Uo(n) {
  return n.join("|");
}
function jo(n) {
  const i = pr(n);
  let o = 0, u = dr.length - 1;
  for (; o <= u; ) {
    const d = Math.floor((o + u) / 2), p = dr[d], v = pr(p);
    if (v === i)
      return p;
    v < i ? o = d + 1 : u = d - 1;
  }
  return "None";
}
function pr(n) {
  return n.toLowerCase().replace(/_-\[\]/g, "");
}
var Tr = (() => {
  var n = import.meta.url;
  return function(i = {}) {
    var o = i, u, d;
    o.ready = new Promise((e, t) => {
      u = e, d = t;
    });
    var p = Object.assign({}, o), v = "./this.program", b = typeof window == "object", $ = typeof importScripts == "function";
    typeof process == "object" && typeof process.versions == "object" && process.versions.node;
    var y = "";
    function _(e) {
      return o.locateFile ? o.locateFile(e, y) : y + e;
    }
    var P;
    (b || $) && ($ ? y = self.location.href : typeof document < "u" && document.currentScript && (y = document.currentScript.src), n && (y = n), y.indexOf("blob:") !== 0 ? y = y.substr(0, y.replace(/[?#].*/, "").lastIndexOf("/") + 1) : y = "", $ && (P = (e) => {
      var t = new XMLHttpRequest();
      return t.open("GET", e, !1), t.responseType = "arraybuffer", t.send(null), new Uint8Array(t.response);
    })), o.print || console.log.bind(console);
    var w = o.printErr || console.error.bind(console);
    Object.assign(o, p), p = null, o.arguments && o.arguments, o.thisProgram && (v = o.thisProgram), o.quit && o.quit;
    var M;
    o.wasmBinary && (M = o.wasmBinary), o.noExitRuntime, typeof WebAssembly != "object" && We("no native wasm support detected");
    var A, E, G = !1, j, H, ee, he, V, L, ke, Fe;
    function Ue() {
      var e = A.buffer;
      o.HEAP8 = j = new Int8Array(e), o.HEAP16 = ee = new Int16Array(e), o.HEAP32 = V = new Int32Array(e), o.HEAPU8 = H = new Uint8Array(e), o.HEAPU16 = he = new Uint16Array(e), o.HEAPU32 = L = new Uint32Array(e), o.HEAPF32 = ke = new Float32Array(e), o.HEAPF64 = Fe = new Float64Array(e);
    }
    var be, Pe = [], je = [], Ie = [];
    function se() {
      if (o.preRun)
        for (typeof o.preRun == "function" && (o.preRun = [o.preRun]); o.preRun.length; )
          ot(o.preRun.shift());
      ct(Pe);
    }
    function K() {
      ct(je);
    }
    function at() {
      if (o.postRun)
        for (typeof o.postRun == "function" && (o.postRun = [o.postRun]); o.postRun.length; )
          st(o.postRun.shift());
      ct(Ie);
    }
    function ot(e) {
      Pe.unshift(e);
    }
    function it(e) {
      je.unshift(e);
    }
    function st(e) {
      Ie.unshift(e);
    }
    var te = 0, ve = null;
    function Lr(e) {
      te++, o.monitorRunDependencies && o.monitorRunDependencies(te);
    }
    function Vr(e) {
      if (te--, o.monitorRunDependencies && o.monitorRunDependencies(te), te == 0 && ve) {
        var t = ve;
        ve = null, t();
      }
    }
    function We(e) {
      o.onAbort && o.onAbort(e), e = "Aborted(" + e + ")", w(e), G = !0, e += ". Build with -sASSERTIONS for more info.";
      var t = new WebAssembly.RuntimeError(e);
      throw d(t), t;
    }
    var zr = "data:application/octet-stream;base64,";
    function Tt(e) {
      return e.startsWith(zr);
    }
    var me;
    o.locateFile ? (me = "zxing_reader.wasm", Tt(me) || (me = _(me))) : me = new URL("/reader/zxing_reader.wasm", self.location).href;
    function Et(e) {
      if (e == me && M)
        return new Uint8Array(M);
      if (P)
        return P(e);
      throw "both async and sync fetching of the wasm failed";
    }
    function Gr(e) {
      return !M && (b || $) && typeof fetch == "function" ? fetch(e, { credentials: "same-origin" }).then((t) => {
        if (!t.ok)
          throw "failed to load wasm binary file at '" + e + "'";
        return t.arrayBuffer();
      }).catch(() => Et(e)) : Promise.resolve().then(() => Et(e));
    }
    function Ot(e, t, r) {
      return Gr(e).then((a) => WebAssembly.instantiate(a, t)).then((a) => a).then(r, (a) => {
        w("failed to asynchronously prepare wasm: " + a), We(a);
      });
    }
    function qr(e, t, r, a) {
      return !e && typeof WebAssembly.instantiateStreaming == "function" && !Tt(t) && typeof fetch == "function" ? fetch(t, { credentials: "same-origin" }).then((s) => {
        var c = WebAssembly.instantiateStreaming(s, r);
        return c.then(a, function(l) {
          return w("wasm streaming compile failed: " + l), w("falling back to ArrayBuffer instantiation"), Ot(t, r, a);
        });
      }) : Ot(t, r, a);
    }
    function Br() {
      var e = { a: xa };
      function t(a, s) {
        var c = a.exports;
        return E = c, A = E.qa, Ue(), be = E.ua, it(E.ra), Vr(), c;
      }
      Lr();
      function r(a) {
        t(a.instance);
      }
      if (o.instantiateWasm)
        try {
          return o.instantiateWasm(e, t);
        } catch (a) {
          w("Module.instantiateWasm callback failed with error: " + a), d(a);
        }
      return qr(M, me, e, r).catch(d), {};
    }
    var ct = (e) => {
      for (; e.length > 0; )
        e.shift()(o);
    }, He = [], Le = 0;
    function Nr(e) {
      var t = new Ve(e);
      return t.get_caught() || (t.set_caught(!0), Le--), t.set_rethrown(!1), He.push(t), rr(t.excPtr), t.get_exception_ptr();
    }
    var re = 0;
    function Yr() {
      D(0, 0);
      var e = He.pop();
      tr(e.excPtr), re = 0;
    }
    function Ve(e) {
      this.excPtr = e, this.ptr = e - 24, this.set_type = function(t) {
        L[this.ptr + 4 >> 2] = t;
      }, this.get_type = function() {
        return L[this.ptr + 4 >> 2];
      }, this.set_destructor = function(t) {
        L[this.ptr + 8 >> 2] = t;
      }, this.get_destructor = function() {
        return L[this.ptr + 8 >> 2];
      }, this.set_caught = function(t) {
        t = t ? 1 : 0, j[this.ptr + 12 >> 0] = t;
      }, this.get_caught = function() {
        return j[this.ptr + 12 >> 0] != 0;
      }, this.set_rethrown = function(t) {
        t = t ? 1 : 0, j[this.ptr + 13 >> 0] = t;
      }, this.get_rethrown = function() {
        return j[this.ptr + 13 >> 0] != 0;
      }, this.init = function(t, r) {
        this.set_adjusted_ptr(0), this.set_type(t), this.set_destructor(r);
      }, this.set_adjusted_ptr = function(t) {
        L[this.ptr + 16 >> 2] = t;
      }, this.get_adjusted_ptr = function() {
        return L[this.ptr + 16 >> 2];
      }, this.get_exception_ptr = function() {
        var t = ar(this.get_type());
        if (t)
          return L[this.excPtr >> 2];
        var r = this.get_adjusted_ptr();
        return r !== 0 ? r : this.excPtr;
      };
    }
    function Jr(e) {
      throw re || (re = e), re;
    }
    var ut = (e) => {
      var t = re;
      if (!t)
        return Re(0), 0;
      var r = new Ve(t);
      r.set_adjusted_ptr(t);
      var a = r.get_type();
      if (!a)
        return Re(0), t;
      for (var s in e) {
        var c = e[s];
        if (c === 0 || c === a)
          break;
        var l = r.ptr + 16;
        if (nr(c, a, l))
          return Re(c), t;
      }
      return Re(a), t;
    }, Qr = () => ut([]), Xr = (e) => ut([e]), Kr = (e, t) => ut([e, t]);
    function Zr(e) {
      var t = new Ve(e).get_exception_ptr();
      return t;
    }
    function en() {
      var e = He.pop();
      e || We("no exception to throw");
      var t = e.excPtr;
      throw e.get_rethrown() || (He.push(e), e.set_rethrown(!0), e.set_caught(!1), Le++), re = t, re;
    }
    function tn(e, t, r) {
      var a = new Ve(e);
      throw a.init(t, r), re = e, Le++, re;
    }
    function rn() {
      return Le;
    }
    var ze = {};
    function Mt(e) {
      for (; e.length; ) {
        var t = e.pop(), r = e.pop();
        r(t);
      }
    }
    function Te(e) {
      return this.fromWireType(V[e >> 2]);
    }
    var Ce = {}, ye = {}, Ge = {}, At = void 0;
    function qe(e) {
      throw new At(e);
    }
    function ge(e, t, r) {
      e.forEach(function(f) {
        Ge[f] = t;
      });
      function a(f) {
        var h = r(f);
        h.length !== e.length && qe("Mismatched type converter count");
        for (var m = 0; m < e.length; ++m)
          ne(e[m], h[m]);
      }
      var s = new Array(t.length), c = [], l = 0;
      t.forEach((f, h) => {
        ye.hasOwnProperty(f) ? s[h] = ye[f] : (c.push(f), Ce.hasOwnProperty(f) || (Ce[f] = []), Ce[f].push(() => {
          s[h] = ye[f], ++l, l === c.length && a(s);
        }));
      }), c.length === 0 && a(s);
    }
    var nn = function(e) {
      var t = ze[e];
      delete ze[e];
      var r = t.rawConstructor, a = t.rawDestructor, s = t.fields, c = s.map((l) => l.getterReturnType).concat(s.map((l) => l.setterArgumentType));
      ge([e], c, (l) => {
        var f = {};
        return s.forEach((h, m) => {
          var C = h.fieldName, T = l[m], O = h.getter, k = h.getterContext, I = l[m + s.length], B = h.setter, W = h.setterContext;
          f[C] = { read: (N) => T.fromWireType(O(k, N)), write: (N, g) => {
            var S = [];
            B(W, N, I.toWireType(S, g)), Mt(S);
          } };
        }), [{ name: t.name, fromWireType: function(h) {
          var m = {};
          for (var C in f)
            m[C] = f[C].read(h);
          return a(h), m;
        }, toWireType: function(h, m) {
          for (var C in f)
            if (!(C in m))
              throw new TypeError(`Missing field: "${C}"`);
          var T = r();
          for (C in f)
            f[C].write(T, m[C]);
          return h !== null && h.push(a, T), T;
        }, argPackAdvance: 8, readValueFromPointer: Te, destructorFunction: a }];
      });
    };
    function an(e, t, r, a, s) {
    }
    function lt(e) {
      switch (e) {
        case 1:
          return 0;
        case 2:
          return 1;
        case 4:
          return 2;
        case 8:
          return 3;
        default:
          throw new TypeError(`Unknown type size: ${e}`);
      }
    }
    function on() {
      for (var e = new Array(256), t = 0; t < 256; ++t)
        e[t] = String.fromCharCode(t);
      Dt = e;
    }
    var Dt = void 0;
    function Y(e) {
      for (var t = "", r = e; H[r]; )
        t += Dt[H[r++]];
      return t;
    }
    var _e = void 0;
    function F(e) {
      throw new _e(e);
    }
    function sn(e, t, r = {}) {
      var a = t.name;
      if (e || F(`type "${a}" must have a positive integer typeid pointer`), ye.hasOwnProperty(e)) {
        if (r.ignoreDuplicateRegistrations)
          return;
        F(`Cannot register type '${a}' twice`);
      }
      if (ye[e] = t, delete Ge[e], Ce.hasOwnProperty(e)) {
        var s = Ce[e];
        delete Ce[e], s.forEach((c) => c());
      }
    }
    function ne(e, t, r = {}) {
      if (!("argPackAdvance" in t))
        throw new TypeError("registerType registeredInstance requires argPackAdvance");
      return sn(e, t, r);
    }
    function cn(e, t, r, a, s) {
      var c = lt(r);
      t = Y(t), ne(e, { name: t, fromWireType: function(l) {
        return !!l;
      }, toWireType: function(l, f) {
        return f ? a : s;
      }, argPackAdvance: 8, readValueFromPointer: function(l) {
        var f;
        if (r === 1)
          f = j;
        else if (r === 2)
          f = ee;
        else if (r === 4)
          f = V;
        else
          throw new TypeError("Unknown boolean type size: " + t);
        return this.fromWireType(f[l >> c]);
      }, destructorFunction: null });
    }
    function un(e) {
      if (!(this instanceof ce) || !(e instanceof ce))
        return !1;
      for (var t = this.$$.ptrType.registeredClass, r = this.$$.ptr, a = e.$$.ptrType.registeredClass, s = e.$$.ptr; t.baseClass; )
        r = t.upcast(r), t = t.baseClass;
      for (; a.baseClass; )
        s = a.upcast(s), a = a.baseClass;
      return t === a && r === s;
    }
    function ln(e) {
      return { count: e.count, deleteScheduled: e.deleteScheduled, preservePointerOnDelete: e.preservePointerOnDelete, ptr: e.ptr, ptrType: e.ptrType, smartPtr: e.smartPtr, smartPtrType: e.smartPtrType };
    }
    function ft(e) {
      function t(r) {
        return r.$$.ptrType.registeredClass.name;
      }
      F(t(e) + " instance already deleted");
    }
    var dt = !1;
    function Rt(e) {
    }
    function fn(e) {
      e.smartPtr ? e.smartPtrType.rawDestructor(e.smartPtr) : e.ptrType.registeredClass.rawDestructor(e.ptr);
    }
    function xt(e) {
      e.count.value -= 1;
      var t = e.count.value === 0;
      t && fn(e);
    }
    function kt(e, t, r) {
      if (t === r)
        return e;
      if (r.baseClass === void 0)
        return null;
      var a = kt(e, t, r.baseClass);
      return a === null ? null : r.downcast(a);
    }
    var Ft = {};
    function dn() {
      return Object.keys(Me).length;
    }
    function pn() {
      var e = [];
      for (var t in Me)
        Me.hasOwnProperty(t) && e.push(Me[t]);
      return e;
    }
    var Ee = [];
    function pt() {
      for (; Ee.length; ) {
        var e = Ee.pop();
        e.$$.deleteScheduled = !1, e.delete();
      }
    }
    var Oe = void 0;
    function hn(e) {
      Oe = e, Ee.length && Oe && Oe(pt);
    }
    function vn() {
      o.getInheritedInstanceCount = dn, o.getLiveInheritedInstances = pn, o.flushPendingDeletes = pt, o.setDelayFunction = hn;
    }
    var Me = {};
    function mn(e, t) {
      for (t === void 0 && F("ptr should not be undefined"); e.baseClass; )
        t = e.upcast(t), e = e.baseClass;
      return t;
    }
    function yn(e, t) {
      return t = mn(e, t), Me[t];
    }
    function Be(e, t) {
      (!t.ptrType || !t.ptr) && qe("makeClassHandle requires ptr and ptrType");
      var r = !!t.smartPtrType, a = !!t.smartPtr;
      return r !== a && qe("Both smartPtrType and smartPtr must be specified"), t.count = { value: 1 }, Ae(Object.create(e, { $$: { value: t } }));
    }
    function gn(e) {
      var t = this.getPointee(e);
      if (!t)
        return this.destructor(e), null;
      var r = yn(this.registeredClass, t);
      if (r !== void 0) {
        if (r.$$.count.value === 0)
          return r.$$.ptr = t, r.$$.smartPtr = e, r.clone();
        var a = r.clone();
        return this.destructor(e), a;
      }
      function s() {
        return this.isSmartPointer ? Be(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: t, smartPtrType: this, smartPtr: e }) : Be(this.registeredClass.instancePrototype, { ptrType: this, ptr: e });
      }
      var c = this.registeredClass.getActualType(t), l = Ft[c];
      if (!l)
        return s.call(this);
      var f;
      this.isConst ? f = l.constPointerType : f = l.pointerType;
      var h = kt(t, this.registeredClass, f.registeredClass);
      return h === null ? s.call(this) : this.isSmartPointer ? Be(f.registeredClass.instancePrototype, { ptrType: f, ptr: h, smartPtrType: this, smartPtr: e }) : Be(f.registeredClass.instancePrototype, { ptrType: f, ptr: h });
    }
    var Ae = function(e) {
      return typeof FinalizationRegistry > "u" ? (Ae = (t) => t, e) : (dt = new FinalizationRegistry((t) => {
        xt(t.$$);
      }), Ae = (t) => {
        var r = t.$$, a = !!r.smartPtr;
        if (a) {
          var s = { $$: r };
          dt.register(t, s, t);
        }
        return t;
      }, Rt = (t) => dt.unregister(t), Ae(e));
    };
    function wn() {
      if (this.$$.ptr || ft(this), this.$$.preservePointerOnDelete)
        return this.$$.count.value += 1, this;
      var e = Ae(Object.create(Object.getPrototypeOf(this), { $$: { value: ln(this.$$) } }));
      return e.$$.count.value += 1, e.$$.deleteScheduled = !1, e;
    }
    function bn() {
      this.$$.ptr || ft(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && F("Object already scheduled for deletion"), Rt(this), xt(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
    }
    function Cn() {
      return !this.$$.ptr;
    }
    function _n() {
      return this.$$.ptr || ft(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && F("Object already scheduled for deletion"), Ee.push(this), Ee.length === 1 && Oe && Oe(pt), this.$$.deleteScheduled = !0, this;
    }
    function $n() {
      ce.prototype.isAliasOf = un, ce.prototype.clone = wn, ce.prototype.delete = bn, ce.prototype.isDeleted = Cn, ce.prototype.deleteLater = _n;
    }
    function ce() {
    }
    var Sn = 48, Pn = 57;
    function Ut(e) {
      if (e === void 0)
        return "_unknown";
      e = e.replace(/[^a-zA-Z0-9_]/g, "$");
      var t = e.charCodeAt(0);
      return t >= Sn && t <= Pn ? `_${e}` : e;
    }
    function jt(e, t) {
      return e = Ut(e), { [e]: function() {
        return t.apply(this, arguments);
      } }[e];
    }
    function It(e, t, r) {
      if (e[t].overloadTable === void 0) {
        var a = e[t];
        e[t] = function() {
          return e[t].overloadTable.hasOwnProperty(arguments.length) || F(`Function '${r}' called with an invalid number of arguments (${arguments.length}) - expects one of (${e[t].overloadTable})!`), e[t].overloadTable[arguments.length].apply(this, arguments);
        }, e[t].overloadTable = [], e[t].overloadTable[a.argCount] = a;
      }
    }
    function Wt(e, t, r) {
      o.hasOwnProperty(e) ? ((r === void 0 || o[e].overloadTable !== void 0 && o[e].overloadTable[r] !== void 0) && F(`Cannot register public name '${e}' twice`), It(o, e, e), o.hasOwnProperty(r) && F(`Cannot register multiple overloads of a function with the same number of arguments (${r})!`), o[e].overloadTable[r] = t) : (o[e] = t, r !== void 0 && (o[e].numArguments = r));
    }
    function Tn(e, t, r, a, s, c, l, f) {
      this.name = e, this.constructor = t, this.instancePrototype = r, this.rawDestructor = a, this.baseClass = s, this.getActualType = c, this.upcast = l, this.downcast = f, this.pureVirtualFunctions = [];
    }
    function ht(e, t, r) {
      for (; t !== r; )
        t.upcast || F(`Expected null or instance of ${r.name}, got an instance of ${t.name}`), e = t.upcast(e), t = t.baseClass;
      return e;
    }
    function En(e, t) {
      if (t === null)
        return this.isReference && F(`null is not a valid ${this.name}`), 0;
      t.$$ || F(`Cannot pass "${yt(t)}" as a ${this.name}`), t.$$.ptr || F(`Cannot pass deleted object as a pointer of type ${this.name}`);
      var r = t.$$.ptrType.registeredClass, a = ht(t.$$.ptr, r, this.registeredClass);
      return a;
    }
    function On(e, t) {
      var r;
      if (t === null)
        return this.isReference && F(`null is not a valid ${this.name}`), this.isSmartPointer ? (r = this.rawConstructor(), e !== null && e.push(this.rawDestructor, r), r) : 0;
      t.$$ || F(`Cannot pass "${yt(t)}" as a ${this.name}`), t.$$.ptr || F(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.isConst && t.$$.ptrType.isConst && F(`Cannot convert argument of type ${t.$$.smartPtrType ? t.$$.smartPtrType.name : t.$$.ptrType.name} to parameter type ${this.name}`);
      var a = t.$$.ptrType.registeredClass;
      if (r = ht(t.$$.ptr, a, this.registeredClass), this.isSmartPointer)
        switch (t.$$.smartPtr === void 0 && F("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
          case 0:
            t.$$.smartPtrType === this ? r = t.$$.smartPtr : F(`Cannot convert argument of type ${t.$$.smartPtrType ? t.$$.smartPtrType.name : t.$$.ptrType.name} to parameter type ${this.name}`);
            break;
          case 1:
            r = t.$$.smartPtr;
            break;
          case 2:
            if (t.$$.smartPtrType === this)
              r = t.$$.smartPtr;
            else {
              var s = t.clone();
              r = this.rawShare(r, ue.toHandle(function() {
                s.delete();
              })), e !== null && e.push(this.rawDestructor, r);
            }
            break;
          default:
            F("Unsupporting sharing policy");
        }
      return r;
    }
    function Mn(e, t) {
      if (t === null)
        return this.isReference && F(`null is not a valid ${this.name}`), 0;
      t.$$ || F(`Cannot pass "${yt(t)}" as a ${this.name}`), t.$$.ptr || F(`Cannot pass deleted object as a pointer of type ${this.name}`), t.$$.ptrType.isConst && F(`Cannot convert argument of type ${t.$$.ptrType.name} to parameter type ${this.name}`);
      var r = t.$$.ptrType.registeredClass, a = ht(t.$$.ptr, r, this.registeredClass);
      return a;
    }
    function An(e) {
      return this.rawGetPointee && (e = this.rawGetPointee(e)), e;
    }
    function Dn(e) {
      this.rawDestructor && this.rawDestructor(e);
    }
    function Rn(e) {
      e !== null && e.delete();
    }
    function xn() {
      ae.prototype.getPointee = An, ae.prototype.destructor = Dn, ae.prototype.argPackAdvance = 8, ae.prototype.readValueFromPointer = Te, ae.prototype.deleteObject = Rn, ae.prototype.fromWireType = gn;
    }
    function ae(e, t, r, a, s, c, l, f, h, m, C) {
      this.name = e, this.registeredClass = t, this.isReference = r, this.isConst = a, this.isSmartPointer = s, this.pointeeType = c, this.sharingPolicy = l, this.rawGetPointee = f, this.rawConstructor = h, this.rawShare = m, this.rawDestructor = C, !s && t.baseClass === void 0 ? a ? (this.toWireType = En, this.destructorFunction = null) : (this.toWireType = Mn, this.destructorFunction = null) : this.toWireType = On;
    }
    function Ht(e, t, r) {
      o.hasOwnProperty(e) || qe("Replacing nonexistant public symbol"), o[e].overloadTable !== void 0 && r !== void 0 ? o[e].overloadTable[r] = t : (o[e] = t, o[e].argCount = r);
    }
    var kn = (e, t, r) => {
      var a = o["dynCall_" + e];
      return r && r.length ? a.apply(null, [t].concat(r)) : a.call(null, t);
    }, Ne = [], U = (e) => {
      var t = Ne[e];
      return t || (e >= Ne.length && (Ne.length = e + 1), Ne[e] = t = be.get(e)), t;
    }, Fn = (e, t, r) => {
      if (e.includes("j"))
        return kn(e, t, r);
      var a = U(t).apply(null, r);
      return a;
    }, Un = (e, t) => {
      var r = [];
      return function() {
        return r.length = 0, Object.assign(r, arguments), Fn(e, t, r);
      };
    };
    function X(e, t) {
      e = Y(e);
      function r() {
        return e.includes("j") ? Un(e, t) : U(t);
      }
      var a = r();
      return typeof a != "function" && F(`unknown function pointer with signature ${e}: ${t}`), a;
    }
    function jn(e, t) {
      var r = jt(t, function(a) {
        this.name = t, this.message = a;
        var s = new Error(a).stack;
        s !== void 0 && (this.stack = this.toString() + `
` + s.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, r;
    }
    var Lt = void 0;
    function Vt(e) {
      var t = er(e), r = Y(t);
      return oe(t), r;
    }
    function Ye(e, t) {
      var r = [], a = {};
      function s(c) {
        if (!a[c] && !ye[c]) {
          if (Ge[c]) {
            Ge[c].forEach(s);
            return;
          }
          r.push(c), a[c] = !0;
        }
      }
      throw t.forEach(s), new Lt(`${e}: ` + r.map(Vt).join([", "]));
    }
    function In(e, t, r, a, s, c, l, f, h, m, C, T, O) {
      C = Y(C), c = X(s, c), f && (f = X(l, f)), m && (m = X(h, m)), O = X(T, O);
      var k = Ut(C);
      Wt(k, function() {
        Ye(`Cannot construct ${C} due to unbound types`, [a]);
      }), ge([e, t, r], a ? [a] : [], function(I) {
        I = I[0];
        var B, W;
        a ? (B = I.registeredClass, W = B.instancePrototype) : W = ce.prototype;
        var N = jt(k, function() {
          if (Object.getPrototypeOf(this) !== g)
            throw new _e("Use 'new' to construct " + C);
          if (S.constructor_body === void 0)
            throw new _e(C + " has no accessible constructor");
          var Xe = S.constructor_body[arguments.length];
          if (Xe === void 0)
            throw new _e(`Tried to invoke ctor of ${C} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(S.constructor_body).toString()}) parameters instead!`);
          return Xe.apply(this, arguments);
        }), g = Object.create(W, { constructor: { value: N } });
        N.prototype = g;
        var S = new Tn(C, N, g, O, B, c, f, m);
        S.baseClass && (S.baseClass.__derivedClasses === void 0 && (S.baseClass.__derivedClasses = []), S.baseClass.__derivedClasses.push(S));
        var z = new ae(C, S, !0, !1, !1), q = new ae(C + "*", S, !1, !1, !1), we = new ae(C + " const*", S, !1, !0, !1);
        return Ft[e] = { pointerType: q, constPointerType: we }, Ht(k, N), [z, q, we];
      });
    }
    function vt(e, t) {
      for (var r = [], a = 0; a < e; a++)
        r.push(L[t + a * 4 >> 2]);
      return r;
    }
    function mt(e, t, r, a, s, c) {
      var l = t.length;
      l < 2 && F("argTypes array size mismatch! Must at least get return value and 'this' types!");
      for (var f = t[1] !== null && r !== null, h = !1, m = 1; m < t.length; ++m)
        if (t[m] !== null && t[m].destructorFunction === void 0) {
          h = !0;
          break;
        }
      var C = t[0].name !== "void", T = l - 2, O = new Array(T), k = [], I = [];
      return function() {
        arguments.length !== T && F(`function ${e} called with ${arguments.length} arguments, expected ${T} args!`), I.length = 0;
        var B;
        k.length = f ? 2 : 1, k[0] = s, f && (B = t[1].toWireType(I, this), k[1] = B);
        for (var W = 0; W < T; ++W)
          O[W] = t[W + 2].toWireType(I, arguments[W]), k.push(O[W]);
        var N = a.apply(null, k);
        function g(S) {
          if (h)
            Mt(I);
          else
            for (var z = f ? 1 : 2; z < t.length; z++) {
              var q = z === 1 ? B : O[z - 2];
              t[z].destructorFunction !== null && t[z].destructorFunction(q);
            }
          if (C)
            return t[0].fromWireType(S);
        }
        return g(N);
      };
    }
    function Wn(e, t, r, a, s, c) {
      var l = vt(t, r);
      s = X(a, s), ge([], [e], function(f) {
        f = f[0];
        var h = `constructor ${f.name}`;
        if (f.registeredClass.constructor_body === void 0 && (f.registeredClass.constructor_body = []), f.registeredClass.constructor_body[t - 1] !== void 0)
          throw new _e(`Cannot register multiple constructors with identical number of parameters (${t - 1}) for class '${f.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        return f.registeredClass.constructor_body[t - 1] = () => {
          Ye(`Cannot construct ${f.name} due to unbound types`, l);
        }, ge([], l, function(m) {
          return m.splice(1, 0, null), f.registeredClass.constructor_body[t - 1] = mt(h, m, null, s, c), [];
        }), [];
      });
    }
    function Hn(e, t, r, a, s, c, l, f, h) {
      var m = vt(r, a);
      t = Y(t), c = X(s, c), ge([], [e], function(C) {
        C = C[0];
        var T = `${C.name}.${t}`;
        t.startsWith("@@") && (t = Symbol[t.substring(2)]), f && C.registeredClass.pureVirtualFunctions.push(t);
        function O() {
          Ye(`Cannot call ${T} due to unbound types`, m);
        }
        var k = C.registeredClass.instancePrototype, I = k[t];
        return I === void 0 || I.overloadTable === void 0 && I.className !== C.name && I.argCount === r - 2 ? (O.argCount = r - 2, O.className = C.name, k[t] = O) : (It(k, t, T), k[t].overloadTable[r - 2] = O), ge([], m, function(B) {
          var W = mt(T, B, C, c, l);
          return k[t].overloadTable === void 0 ? (W.argCount = r - 2, k[t] = W) : k[t].overloadTable[r - 2] = W, [];
        }), [];
      });
    }
    function Ln() {
      Object.assign(zt.prototype, { get(e) {
        return this.allocated[e];
      }, has(e) {
        return this.allocated[e] !== void 0;
      }, allocate(e) {
        var t = this.freelist.pop() || this.allocated.length;
        return this.allocated[t] = e, t;
      }, free(e) {
        this.allocated[e] = void 0, this.freelist.push(e);
      } });
    }
    function zt() {
      this.allocated = [void 0], this.freelist = [];
    }
    var Q = new zt();
    function Gt(e) {
      e >= Q.reserved && --Q.get(e).refcount === 0 && Q.free(e);
    }
    function Vn() {
      for (var e = 0, t = Q.reserved; t < Q.allocated.length; ++t)
        Q.allocated[t] !== void 0 && ++e;
      return e;
    }
    function zn() {
      Q.allocated.push({ value: void 0 }, { value: null }, { value: !0 }, { value: !1 }), Q.reserved = Q.allocated.length, o.count_emval_handles = Vn;
    }
    var ue = { toValue: (e) => (e || F("Cannot use deleted val. handle = " + e), Q.get(e).value), toHandle: (e) => {
      switch (e) {
        case void 0:
          return 1;
        case null:
          return 2;
        case !0:
          return 3;
        case !1:
          return 4;
        default:
          return Q.allocate({ refcount: 1, value: e });
      }
    } };
    function Gn(e, t) {
      t = Y(t), ne(e, { name: t, fromWireType: function(r) {
        var a = ue.toValue(r);
        return Gt(r), a;
      }, toWireType: function(r, a) {
        return ue.toHandle(a);
      }, argPackAdvance: 8, readValueFromPointer: Te, destructorFunction: null });
    }
    function yt(e) {
      if (e === null)
        return "null";
      var t = typeof e;
      return t === "object" || t === "array" || t === "function" ? e.toString() : "" + e;
    }
    function qn(e, t) {
      switch (t) {
        case 2:
          return function(r) {
            return this.fromWireType(ke[r >> 2]);
          };
        case 3:
          return function(r) {
            return this.fromWireType(Fe[r >> 3]);
          };
        default:
          throw new TypeError("Unknown float type: " + e);
      }
    }
    function Bn(e, t, r) {
      var a = lt(r);
      t = Y(t), ne(e, { name: t, fromWireType: function(s) {
        return s;
      }, toWireType: function(s, c) {
        return c;
      }, argPackAdvance: 8, readValueFromPointer: qn(t, a), destructorFunction: null });
    }
    function Nn(e, t, r, a, s, c, l) {
      var f = vt(t, r);
      e = Y(e), s = X(a, s), Wt(e, function() {
        Ye(`Cannot call ${e} due to unbound types`, f);
      }, t - 1), ge([], f, function(h) {
        var m = [h[0], null].concat(h.slice(1));
        return Ht(e, mt(e, m, null, s, c), t - 1), [];
      });
    }
    function Yn(e, t, r) {
      switch (t) {
        case 0:
          return r ? function(a) {
            return j[a];
          } : function(a) {
            return H[a];
          };
        case 1:
          return r ? function(a) {
            return ee[a >> 1];
          } : function(a) {
            return he[a >> 1];
          };
        case 2:
          return r ? function(a) {
            return V[a >> 2];
          } : function(a) {
            return L[a >> 2];
          };
        default:
          throw new TypeError("Unknown integer type: " + e);
      }
    }
    function Jn(e, t, r, a, s) {
      t = Y(t);
      var c = lt(r), l = (T) => T;
      if (a === 0) {
        var f = 32 - 8 * r;
        l = (T) => T << f >>> f;
      }
      var h = t.includes("unsigned"), m = (T, O) => {
      }, C;
      h ? C = function(T, O) {
        return m(O, this.name), O >>> 0;
      } : C = function(T, O) {
        return m(O, this.name), O;
      }, ne(e, { name: t, fromWireType: l, toWireType: C, argPackAdvance: 8, readValueFromPointer: Yn(t, c, a !== 0), destructorFunction: null });
    }
    function Qn(e, t, r) {
      var a = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], s = a[t];
      function c(l) {
        l = l >> 2;
        var f = L, h = f[l], m = f[l + 1];
        return new s(f.buffer, m, h);
      }
      r = Y(r), ne(e, { name: r, fromWireType: c, argPackAdvance: 8, readValueFromPointer: c }, { ignoreDuplicateRegistrations: !0 });
    }
    var qt = (e, t, r, a) => {
      if (!(a > 0))
        return 0;
      for (var s = r, c = r + a - 1, l = 0; l < e.length; ++l) {
        var f = e.charCodeAt(l);
        if (f >= 55296 && f <= 57343) {
          var h = e.charCodeAt(++l);
          f = 65536 + ((f & 1023) << 10) | h & 1023;
        }
        if (f <= 127) {
          if (r >= c)
            break;
          t[r++] = f;
        } else if (f <= 2047) {
          if (r + 1 >= c)
            break;
          t[r++] = 192 | f >> 6, t[r++] = 128 | f & 63;
        } else if (f <= 65535) {
          if (r + 2 >= c)
            break;
          t[r++] = 224 | f >> 12, t[r++] = 128 | f >> 6 & 63, t[r++] = 128 | f & 63;
        } else {
          if (r + 3 >= c)
            break;
          t[r++] = 240 | f >> 18, t[r++] = 128 | f >> 12 & 63, t[r++] = 128 | f >> 6 & 63, t[r++] = 128 | f & 63;
        }
      }
      return t[r] = 0, r - s;
    }, Xn = (e, t, r) => qt(e, H, t, r), Bt = (e) => {
      for (var t = 0, r = 0; r < e.length; ++r) {
        var a = e.charCodeAt(r);
        a <= 127 ? t++ : a <= 2047 ? t += 2 : a >= 55296 && a <= 57343 ? (t += 4, ++r) : t += 3;
      }
      return t;
    }, Nt = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, Kn = (e, t, r) => {
      for (var a = t + r, s = t; e[s] && !(s >= a); )
        ++s;
      if (s - t > 16 && e.buffer && Nt)
        return Nt.decode(e.subarray(t, s));
      for (var c = ""; t < s; ) {
        var l = e[t++];
        if (!(l & 128)) {
          c += String.fromCharCode(l);
          continue;
        }
        var f = e[t++] & 63;
        if ((l & 224) == 192) {
          c += String.fromCharCode((l & 31) << 6 | f);
          continue;
        }
        var h = e[t++] & 63;
        if ((l & 240) == 224 ? l = (l & 15) << 12 | f << 6 | h : l = (l & 7) << 18 | f << 12 | h << 6 | e[t++] & 63, l < 65536)
          c += String.fromCharCode(l);
        else {
          var m = l - 65536;
          c += String.fromCharCode(55296 | m >> 10, 56320 | m & 1023);
        }
      }
      return c;
    }, gt = (e, t) => e ? Kn(H, e, t) : "";
    function Zn(e, t) {
      t = Y(t);
      var r = t === "std::string";
      ne(e, { name: t, fromWireType: function(a) {
        var s = L[a >> 2], c = a + 4, l;
        if (r)
          for (var f = c, h = 0; h <= s; ++h) {
            var m = c + h;
            if (h == s || H[m] == 0) {
              var C = m - f, T = gt(f, C);
              l === void 0 ? l = T : (l += String.fromCharCode(0), l += T), f = m + 1;
            }
          }
        else {
          for (var O = new Array(s), h = 0; h < s; ++h)
            O[h] = String.fromCharCode(H[c + h]);
          l = O.join("");
        }
        return oe(a), l;
      }, toWireType: function(a, s) {
        s instanceof ArrayBuffer && (s = new Uint8Array(s));
        var c, l = typeof s == "string";
        l || s instanceof Uint8Array || s instanceof Uint8ClampedArray || s instanceof Int8Array || F("Cannot pass non-string to std::string"), r && l ? c = Bt(s) : c = s.length;
        var f = bt(4 + c + 1), h = f + 4;
        if (L[f >> 2] = c, r && l)
          Xn(s, h, c + 1);
        else if (l)
          for (var m = 0; m < c; ++m) {
            var C = s.charCodeAt(m);
            C > 255 && (oe(h), F("String has UTF-16 code units that do not fit in 8 bits")), H[h + m] = C;
          }
        else
          for (var m = 0; m < c; ++m)
            H[h + m] = s[m];
        return a !== null && a.push(oe, f), f;
      }, argPackAdvance: 8, readValueFromPointer: Te, destructorFunction: function(a) {
        oe(a);
      } });
    }
    var Yt = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, ea = (e, t) => {
      for (var r = e, a = r >> 1, s = a + t / 2; !(a >= s) && he[a]; )
        ++a;
      if (r = a << 1, r - e > 32 && Yt)
        return Yt.decode(H.subarray(e, r));
      for (var c = "", l = 0; !(l >= t / 2); ++l) {
        var f = ee[e + l * 2 >> 1];
        if (f == 0)
          break;
        c += String.fromCharCode(f);
      }
      return c;
    }, ta = (e, t, r) => {
      if (r === void 0 && (r = 2147483647), r < 2)
        return 0;
      r -= 2;
      for (var a = t, s = r < e.length * 2 ? r / 2 : e.length, c = 0; c < s; ++c) {
        var l = e.charCodeAt(c);
        ee[t >> 1] = l, t += 2;
      }
      return ee[t >> 1] = 0, t - a;
    }, ra = (e) => e.length * 2, na = (e, t) => {
      for (var r = 0, a = ""; !(r >= t / 4); ) {
        var s = V[e + r * 4 >> 2];
        if (s == 0)
          break;
        if (++r, s >= 65536) {
          var c = s - 65536;
          a += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        } else
          a += String.fromCharCode(s);
      }
      return a;
    }, aa = (e, t, r) => {
      if (r === void 0 && (r = 2147483647), r < 4)
        return 0;
      for (var a = t, s = a + r - 4, c = 0; c < e.length; ++c) {
        var l = e.charCodeAt(c);
        if (l >= 55296 && l <= 57343) {
          var f = e.charCodeAt(++c);
          l = 65536 + ((l & 1023) << 10) | f & 1023;
        }
        if (V[t >> 2] = l, t += 4, t + 4 > s)
          break;
      }
      return V[t >> 2] = 0, t - a;
    }, oa = (e) => {
      for (var t = 0, r = 0; r < e.length; ++r) {
        var a = e.charCodeAt(r);
        a >= 55296 && a <= 57343 && ++r, t += 4;
      }
      return t;
    }, ia = function(e, t, r) {
      r = Y(r);
      var a, s, c, l, f;
      t === 2 ? (a = ea, s = ta, l = ra, c = () => he, f = 1) : t === 4 && (a = na, s = aa, l = oa, c = () => L, f = 2), ne(e, { name: r, fromWireType: function(h) {
        for (var m = L[h >> 2], C = c(), T, O = h + 4, k = 0; k <= m; ++k) {
          var I = h + 4 + k * t;
          if (k == m || C[I >> f] == 0) {
            var B = I - O, W = a(O, B);
            T === void 0 ? T = W : (T += String.fromCharCode(0), T += W), O = I + t;
          }
        }
        return oe(h), T;
      }, toWireType: function(h, m) {
        typeof m != "string" && F(`Cannot pass non-string to C++ string type ${r}`);
        var C = l(m), T = bt(4 + C + t);
        return L[T >> 2] = C >> f, s(m, T + 4, C + t), h !== null && h.push(oe, T), T;
      }, argPackAdvance: 8, readValueFromPointer: Te, destructorFunction: function(h) {
        oe(h);
      } });
    };
    function sa(e, t, r, a, s, c) {
      ze[e] = { name: Y(t), rawConstructor: X(r, a), rawDestructor: X(s, c), fields: [] };
    }
    function ca(e, t, r, a, s, c, l, f, h, m) {
      ze[e].fields.push({ fieldName: Y(t), getterReturnType: r, getter: X(a, s), getterContext: c, setterArgumentType: l, setter: X(f, h), setterContext: m });
    }
    function ua(e, t) {
      t = Y(t), ne(e, { isVoid: !0, name: t, argPackAdvance: 0, fromWireType: function() {
      }, toWireType: function(r, a) {
      } });
    }
    var la = {};
    function fa(e) {
      var t = la[e];
      return t === void 0 ? Y(e) : t;
    }
    function Jt() {
      if (typeof globalThis == "object")
        return globalThis;
      function e(t) {
        t.$$$embind_global$$$ = t;
        var r = typeof $$$embind_global$$$ == "object" && t.$$$embind_global$$$ == t;
        return r || delete t.$$$embind_global$$$, r;
      }
      if (typeof $$$embind_global$$$ == "object" || (typeof global == "object" && e(global) ? $$$embind_global$$$ = global : typeof self == "object" && e(self) && ($$$embind_global$$$ = self), typeof $$$embind_global$$$ == "object"))
        return $$$embind_global$$$;
      throw Error("unable to get global object.");
    }
    function da(e) {
      return e === 0 ? ue.toHandle(Jt()) : (e = fa(e), ue.toHandle(Jt()[e]));
    }
    function pa(e) {
      e > 4 && (Q.get(e).refcount += 1);
    }
    function Qt(e, t) {
      var r = ye[e];
      return r === void 0 && F(t + " has unknown type " + Vt(e)), r;
    }
    function ha(e) {
      var t = new Array(e + 1);
      return function(r, a, s) {
        t[0] = r;
        for (var c = 0; c < e; ++c) {
          var l = Qt(L[a + c * 4 >> 2], "parameter " + c);
          t[c + 1] = l.readValueFromPointer(s), s += l.argPackAdvance;
        }
        var f = new (r.bind.apply(r, t))();
        return ue.toHandle(f);
      };
    }
    var Xt = {};
    function va(e, t, r, a) {
      e = ue.toValue(e);
      var s = Xt[t];
      return s || (s = ha(t), Xt[t] = s), s(e, r, a);
    }
    function ma(e, t) {
      e = Qt(e, "_emval_take_value");
      var r = e.readValueFromPointer(t);
      return ue.toHandle(r);
    }
    var ya = () => {
      We("");
    }, ga = (e, t, r) => H.copyWithin(e, t, t + r), wa = () => 2147483648, ba = (e) => {
      var t = A.buffer, r = e - t.byteLength + 65535 >>> 16;
      try {
        return A.grow(r), Ue(), 1;
      } catch {
      }
    }, Ca = (e) => {
      var t = H.length;
      e >>>= 0;
      var r = wa();
      if (e > r)
        return !1;
      for (var a = (h, m) => h + (m - h % m) % m, s = 1; s <= 4; s *= 2) {
        var c = t * (1 + 0.2 / s);
        c = Math.min(c, e + 100663296);
        var l = Math.min(r, a(Math.max(e, c), 65536)), f = ba(l);
        if (f)
          return !0;
      }
      return !1;
    }, wt = {}, _a = () => v || "./this.program", De = () => {
      if (!De.strings) {
        var e = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", t = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: e, _: _a() };
        for (var r in wt)
          wt[r] === void 0 ? delete t[r] : t[r] = wt[r];
        var a = [];
        for (var r in t)
          a.push(`${r}=${t[r]}`);
        De.strings = a;
      }
      return De.strings;
    }, $a = (e, t) => {
      for (var r = 0; r < e.length; ++r)
        j[t++ >> 0] = e.charCodeAt(r);
      j[t >> 0] = 0;
    }, Sa = (e, t) => {
      var r = 0;
      return De().forEach(function(a, s) {
        var c = t + r;
        L[e + s * 4 >> 2] = c, $a(a, c), r += a.length + 1;
      }), 0;
    }, Pa = (e, t) => {
      var r = De();
      L[e >> 2] = r.length;
      var a = 0;
      return r.forEach(function(s) {
        a += s.length + 1;
      }), L[t >> 2] = a, 0;
    };
    function Ta(e) {
      return e;
    }
    var Je = (e) => e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0), Ea = (e, t) => {
      for (var r = 0, a = 0; a <= t; r += e[a++])
        ;
      return r;
    }, Kt = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Zt = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Oa = (e, t) => {
      for (var r = new Date(e.getTime()); t > 0; ) {
        var a = Je(r.getFullYear()), s = r.getMonth(), c = (a ? Kt : Zt)[s];
        if (t > c - r.getDate())
          t -= c - r.getDate() + 1, r.setDate(1), s < 11 ? r.setMonth(s + 1) : (r.setMonth(0), r.setFullYear(r.getFullYear() + 1));
        else
          return r.setDate(r.getDate() + t), r;
      }
      return r;
    };
    function Ma(e, t, r) {
      var a = r > 0 ? r : Bt(e) + 1, s = new Array(a), c = qt(e, s, 0, s.length);
      return t && (s.length = c), s;
    }
    var Aa = (e, t) => {
      j.set(e, t);
    }, Da = (e, t, r, a) => {
      var s = V[a + 40 >> 2], c = { tm_sec: V[a >> 2], tm_min: V[a + 4 >> 2], tm_hour: V[a + 8 >> 2], tm_mday: V[a + 12 >> 2], tm_mon: V[a + 16 >> 2], tm_year: V[a + 20 >> 2], tm_wday: V[a + 24 >> 2], tm_yday: V[a + 28 >> 2], tm_isdst: V[a + 32 >> 2], tm_gmtoff: V[a + 36 >> 2], tm_zone: s ? gt(s) : "" }, l = gt(r), f = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
      for (var h in f)
        l = l.replace(new RegExp(h, "g"), f[h]);
      var m = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], C = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      function T(g, S, z) {
        for (var q = typeof g == "number" ? g.toString() : g || ""; q.length < S; )
          q = z[0] + q;
        return q;
      }
      function O(g, S) {
        return T(g, S, "0");
      }
      function k(g, S) {
        function z(we) {
          return we < 0 ? -1 : we > 0 ? 1 : 0;
        }
        var q;
        return (q = z(g.getFullYear() - S.getFullYear())) === 0 && (q = z(g.getMonth() - S.getMonth())) === 0 && (q = z(g.getDate() - S.getDate())), q;
      }
      function I(g) {
        switch (g.getDay()) {
          case 0:
            return new Date(g.getFullYear() - 1, 11, 29);
          case 1:
            return g;
          case 2:
            return new Date(g.getFullYear(), 0, 3);
          case 3:
            return new Date(g.getFullYear(), 0, 2);
          case 4:
            return new Date(g.getFullYear(), 0, 1);
          case 5:
            return new Date(g.getFullYear() - 1, 11, 31);
          case 6:
            return new Date(g.getFullYear() - 1, 11, 30);
        }
      }
      function B(g) {
        var S = Oa(new Date(g.tm_year + 1900, 0, 1), g.tm_yday), z = new Date(S.getFullYear(), 0, 4), q = new Date(S.getFullYear() + 1, 0, 4), we = I(z), Xe = I(q);
        return k(we, S) <= 0 ? k(Xe, S) <= 0 ? S.getFullYear() + 1 : S.getFullYear() : S.getFullYear() - 1;
      }
      var W = { "%a": (g) => m[g.tm_wday].substring(0, 3), "%A": (g) => m[g.tm_wday], "%b": (g) => C[g.tm_mon].substring(0, 3), "%B": (g) => C[g.tm_mon], "%C": (g) => {
        var S = g.tm_year + 1900;
        return O(S / 100 | 0, 2);
      }, "%d": (g) => O(g.tm_mday, 2), "%e": (g) => T(g.tm_mday, 2, " "), "%g": (g) => B(g).toString().substring(2), "%G": (g) => B(g), "%H": (g) => O(g.tm_hour, 2), "%I": (g) => {
        var S = g.tm_hour;
        return S == 0 ? S = 12 : S > 12 && (S -= 12), O(S, 2);
      }, "%j": (g) => O(g.tm_mday + Ea(Je(g.tm_year + 1900) ? Kt : Zt, g.tm_mon - 1), 3), "%m": (g) => O(g.tm_mon + 1, 2), "%M": (g) => O(g.tm_min, 2), "%n": () => `
`, "%p": (g) => g.tm_hour >= 0 && g.tm_hour < 12 ? "AM" : "PM", "%S": (g) => O(g.tm_sec, 2), "%t": () => "	", "%u": (g) => g.tm_wday || 7, "%U": (g) => {
        var S = g.tm_yday + 7 - g.tm_wday;
        return O(Math.floor(S / 7), 2);
      }, "%V": (g) => {
        var S = Math.floor((g.tm_yday + 7 - (g.tm_wday + 6) % 7) / 7);
        if ((g.tm_wday + 371 - g.tm_yday - 2) % 7 <= 2 && S++, S) {
          if (S == 53) {
            var z = (g.tm_wday + 371 - g.tm_yday) % 7;
            z != 4 && (z != 3 || !Je(g.tm_year)) && (S = 1);
          }
        } else {
          S = 52;
          var q = (g.tm_wday + 7 - g.tm_yday - 1) % 7;
          (q == 4 || q == 5 && Je(g.tm_year % 400 - 1)) && S++;
        }
        return O(S, 2);
      }, "%w": (g) => g.tm_wday, "%W": (g) => {
        var S = g.tm_yday + 7 - (g.tm_wday + 6) % 7;
        return O(Math.floor(S / 7), 2);
      }, "%y": (g) => (g.tm_year + 1900).toString().substring(2), "%Y": (g) => g.tm_year + 1900, "%z": (g) => {
        var S = g.tm_gmtoff, z = S >= 0;
        return S = Math.abs(S) / 60, S = S / 60 * 100 + S % 60, (z ? "+" : "-") + ("0000" + S).slice(-4);
      }, "%Z": (g) => g.tm_zone, "%%": () => "%" };
      l = l.replace(/%%/g, "\0\0");
      for (var h in W)
        l.includes(h) && (l = l.replace(new RegExp(h, "g"), W[h](c)));
      l = l.replace(/\0\0/g, "%");
      var N = Ma(l, !1);
      return N.length > t ? 0 : (Aa(N, e), N.length - 1);
    }, Ra = (e, t, r, a, s) => Da(e, t, r, a);
    At = o.InternalError = class extends Error {
      constructor(e) {
        super(e), this.name = "InternalError";
      }
    }, on(), _e = o.BindingError = class extends Error {
      constructor(e) {
        super(e), this.name = "BindingError";
      }
    }, $n(), vn(), xn(), Lt = o.UnboundTypeError = jn(Error, "UnboundTypeError"), Ln(), zn();
    var xa = { q: Nr, u: Yr, a: Qr, h: Xr, l: Kr, I: Zr, P: en, n: tn, ba: rn, d: Jr, oa: nn, Y: an, fa: cn, na: In, ma: Wn, D: Hn, ea: Gn, W: Bn, J: Nn, w: Jn, s: Qn, V: Zn, L: ia, Q: sa, pa: ca, ga: ua, U: Gt, la: da, R: pa, ia: va, ka: ma, K: ya, da: ga, ca: Ca, $: Sa, aa: Pa, H: Ka, T: so, B: eo, p: Ja, b: ka, C: Xa, ha: ro, c: Wa, j: La, i: ja, x: Za, O: Qa, v: Na, G: ao, N: oo, A: to, F: co, Z: lo, X: fo, k: Ha, f: Ia, e: Ua, g: Fa, M: io, m: Ba, o: Va, S: za, t: qa, ja: Ya, y: no, r: Ga, E: uo, z: Ta, _: Ra };
    Br();
    var oe = o._free = (e) => (oe = o._free = E.sa)(e), bt = o._malloc = (e) => (bt = o._malloc = E.ta)(e), er = (e) => (er = E.va)(e);
    o.__embind_initialize_bindings = () => (o.__embind_initialize_bindings = E.wa)();
    var D = (e, t) => (D = E.xa)(e, t), Re = (e) => (Re = E.ya)(e), R = () => (R = E.za)(), x = (e) => (x = E.Aa)(e), tr = (e) => (tr = E.Ba)(e), rr = (e) => (rr = E.Ca)(e), nr = (e, t, r) => (nr = E.Da)(e, t, r), ar = (e) => (ar = E.Ea)(e);
    o.dynCall_viijii = (e, t, r, a, s, c, l) => (o.dynCall_viijii = E.Fa)(e, t, r, a, s, c, l);
    var or = o.dynCall_jiii = (e, t, r, a) => (or = o.dynCall_jiii = E.Ga)(e, t, r, a), ir = o.dynCall_jiiii = (e, t, r, a, s) => (ir = o.dynCall_jiiii = E.Ha)(e, t, r, a, s);
    o.dynCall_iiiiij = (e, t, r, a, s, c, l) => (o.dynCall_iiiiij = E.Ia)(e, t, r, a, s, c, l), o.dynCall_iiiiijj = (e, t, r, a, s, c, l, f, h) => (o.dynCall_iiiiijj = E.Ja)(e, t, r, a, s, c, l, f, h), o.dynCall_iiiiiijj = (e, t, r, a, s, c, l, f, h, m) => (o.dynCall_iiiiiijj = E.Ka)(e, t, r, a, s, c, l, f, h, m);
    function ka(e, t) {
      var r = R();
      try {
        return U(e)(t);
      } catch (a) {
        if (x(r), a !== a + 0)
          throw a;
        D(1, 0);
      }
    }
    function Fa(e, t, r, a) {
      var s = R();
      try {
        U(e)(t, r, a);
      } catch (c) {
        if (x(s), c !== c + 0)
          throw c;
        D(1, 0);
      }
    }
    function Ua(e, t, r) {
      var a = R();
      try {
        U(e)(t, r);
      } catch (s) {
        if (x(a), s !== s + 0)
          throw s;
        D(1, 0);
      }
    }
    function ja(e, t, r, a, s) {
      var c = R();
      try {
        return U(e)(t, r, a, s);
      } catch (l) {
        if (x(c), l !== l + 0)
          throw l;
        D(1, 0);
      }
    }
    function Ia(e, t) {
      var r = R();
      try {
        U(e)(t);
      } catch (a) {
        if (x(r), a !== a + 0)
          throw a;
        D(1, 0);
      }
    }
    function Wa(e, t, r) {
      var a = R();
      try {
        return U(e)(t, r);
      } catch (s) {
        if (x(a), s !== s + 0)
          throw s;
        D(1, 0);
      }
    }
    function Ha(e) {
      var t = R();
      try {
        U(e)();
      } catch (r) {
        if (x(t), r !== r + 0)
          throw r;
        D(1, 0);
      }
    }
    function La(e, t, r, a) {
      var s = R();
      try {
        return U(e)(t, r, a);
      } catch (c) {
        if (x(s), c !== c + 0)
          throw c;
        D(1, 0);
      }
    }
    function Va(e, t, r, a, s, c) {
      var l = R();
      try {
        U(e)(t, r, a, s, c);
      } catch (f) {
        if (x(l), f !== f + 0)
          throw f;
        D(1, 0);
      }
    }
    function za(e, t, r, a, s, c, l) {
      var f = R();
      try {
        U(e)(t, r, a, s, c, l);
      } catch (h) {
        if (x(f), h !== h + 0)
          throw h;
        D(1, 0);
      }
    }
    function Ga(e, t, r, a, s, c, l, f, h, m, C) {
      var T = R();
      try {
        U(e)(t, r, a, s, c, l, f, h, m, C);
      } catch (O) {
        if (x(T), O !== O + 0)
          throw O;
        D(1, 0);
      }
    }
    function qa(e, t, r, a, s, c, l, f) {
      var h = R();
      try {
        U(e)(t, r, a, s, c, l, f);
      } catch (m) {
        if (x(h), m !== m + 0)
          throw m;
        D(1, 0);
      }
    }
    function Ba(e, t, r, a, s) {
      var c = R();
      try {
        U(e)(t, r, a, s);
      } catch (l) {
        if (x(c), l !== l + 0)
          throw l;
        D(1, 0);
      }
    }
    function Na(e, t, r, a, s, c, l) {
      var f = R();
      try {
        return U(e)(t, r, a, s, c, l);
      } catch (h) {
        if (x(f), h !== h + 0)
          throw h;
        D(1, 0);
      }
    }
    function Ya(e, t, r, a, s, c, l, f, h) {
      var m = R();
      try {
        U(e)(t, r, a, s, c, l, f, h);
      } catch (C) {
        if (x(m), C !== C + 0)
          throw C;
        D(1, 0);
      }
    }
    function Ja(e) {
      var t = R();
      try {
        return U(e)();
      } catch (r) {
        if (x(t), r !== r + 0)
          throw r;
        D(1, 0);
      }
    }
    function Qa(e, t, r, a, s, c, l) {
      var f = R();
      try {
        return U(e)(t, r, a, s, c, l);
      } catch (h) {
        if (x(f), h !== h + 0)
          throw h;
        D(1, 0);
      }
    }
    function Xa(e, t, r, a) {
      var s = R();
      try {
        return U(e)(t, r, a);
      } catch (c) {
        if (x(s), c !== c + 0)
          throw c;
        D(1, 0);
      }
    }
    function Ka(e, t, r, a) {
      var s = R();
      try {
        return U(e)(t, r, a);
      } catch (c) {
        if (x(s), c !== c + 0)
          throw c;
        D(1, 0);
      }
    }
    function Za(e, t, r, a, s, c) {
      var l = R();
      try {
        return U(e)(t, r, a, s, c);
      } catch (f) {
        if (x(l), f !== f + 0)
          throw f;
        D(1, 0);
      }
    }
    function eo(e, t, r, a, s, c) {
      var l = R();
      try {
        return U(e)(t, r, a, s, c);
      } catch (f) {
        if (x(l), f !== f + 0)
          throw f;
        D(1, 0);
      }
    }
    function to(e, t, r, a, s, c, l, f, h, m) {
      var C = R();
      try {
        return U(e)(t, r, a, s, c, l, f, h, m);
      } catch (T) {
        if (x(C), T !== T + 0)
          throw T;
        D(1, 0);
      }
    }
    function ro(e, t, r) {
      var a = R();
      try {
        return U(e)(t, r);
      } catch (s) {
        if (x(a), s !== s + 0)
          throw s;
        D(1, 0);
      }
    }
    function no(e, t, r, a, s, c, l, f, h, m) {
      var C = R();
      try {
        U(e)(t, r, a, s, c, l, f, h, m);
      } catch (T) {
        if (x(C), T !== T + 0)
          throw T;
        D(1, 0);
      }
    }
    function ao(e, t, r, a, s, c, l, f) {
      var h = R();
      try {
        return U(e)(t, r, a, s, c, l, f);
      } catch (m) {
        if (x(h), m !== m + 0)
          throw m;
        D(1, 0);
      }
    }
    function oo(e, t, r, a, s, c, l, f, h) {
      var m = R();
      try {
        return U(e)(t, r, a, s, c, l, f, h);
      } catch (C) {
        if (x(m), C !== C + 0)
          throw C;
        D(1, 0);
      }
    }
    function io(e, t, r, a, s, c, l) {
      var f = R();
      try {
        U(e)(t, r, a, s, c, l);
      } catch (h) {
        if (x(f), h !== h + 0)
          throw h;
        D(1, 0);
      }
    }
    function so(e, t, r, a) {
      var s = R();
      try {
        return U(e)(t, r, a);
      } catch (c) {
        if (x(s), c !== c + 0)
          throw c;
        D(1, 0);
      }
    }
    function co(e, t, r, a, s, c, l, f, h, m, C, T) {
      var O = R();
      try {
        return U(e)(t, r, a, s, c, l, f, h, m, C, T);
      } catch (k) {
        if (x(O), k !== k + 0)
          throw k;
        D(1, 0);
      }
    }
    function uo(e, t, r, a, s, c, l, f, h, m, C, T, O, k, I, B) {
      var W = R();
      try {
        U(e)(t, r, a, s, c, l, f, h, m, C, T, O, k, I, B);
      } catch (N) {
        if (x(W), N !== N + 0)
          throw N;
        D(1, 0);
      }
    }
    function lo(e, t, r, a) {
      var s = R();
      try {
        return or(e, t, r, a);
      } catch (c) {
        if (x(s), c !== c + 0)
          throw c;
        D(1, 0);
      }
    }
    function fo(e, t, r, a, s) {
      var c = R();
      try {
        return ir(e, t, r, a, s);
      } catch (l) {
        if (x(c), l !== l + 0)
          throw l;
        D(1, 0);
      }
    }
    var Qe;
    ve = function e() {
      Qe || sr(), Qe || (ve = e);
    };
    function sr() {
      if (te > 0 || (se(), te > 0))
        return;
      function e() {
        Qe || (Qe = !0, o.calledRun = !0, !G && (K(), u(o), o.onRuntimeInitialized && o.onRuntimeInitialized(), at()));
      }
      o.setStatus ? (o.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          o.setStatus("");
        }, 1), e();
      }, 1)) : e();
    }
    if (o.preInit)
      for (typeof o.preInit == "function" && (o.preInit = [o.preInit]); o.preInit.length > 0; )
        o.preInit.pop()();
    return sr(), i.ready;
  };
})();
function hr(n) {
  return Pr(Tr, n);
}
async function Io(n, {
  tryHarder: i = fe.tryHarder,
  formats: o = fe.formats,
  maxSymbols: u = fe.maxSymbols
} = fe) {
  return Fo(
    n,
    {
      tryHarder: i,
      formats: o,
      maxSymbols: u
    },
    Tr
  );
}
const Er = /* @__PURE__ */ new Map([
  ["aztec", "Aztec"],
  ["code_128", "Code128"],
  ["code_39", "Code39"],
  ["code_93", "Code93"],
  ["codabar", "Codabar"],
  ["data_matrix", "DataMatrix"],
  ["ean_13", "EAN-13"],
  ["ean_8", "EAN-8"],
  ["itf", "ITF"],
  ["pdf417", "PDF417"],
  ["qr_code", "QRCode"],
  ["upc_a", "UPC-A"],
  ["upc_e", "UPC-E"]
]);
function Wo(n) {
  for (const [i, o] of Er)
    if (n === o)
      return i;
  return "unknown";
}
var et;
class Pt {
  constructor(i = {}) {
    wo(this, et, void 0);
    var o, u;
    if (((o = i == null ? void 0 : i.formats) == null ? void 0 : o.length) === 0)
      throw new TypeError("formats cannot be empty");
    (u = i == null ? void 0 : i.formats) == null || u.forEach((d) => {
      if (d === "unknown")
        throw new TypeError("format unknown is not supported");
      if (!lr.includes(d))
        throw new TypeError(`format ${d} is not supported`);
    }), hr(), bo(this, et, (i == null ? void 0 : i.formats) ?? []);
  }
  static async getSupportedFormats() {
    return await hr(), lr.filter((i) => i !== "unknown");
  }
  async detect(i) {
    const o = await Mo(i);
    return o === null ? [] : (await Io(o, {
      tryHarder: !0,
      formats: go(this, et).map(
        (u) => Er.get(u)
      )
    })).map((u) => {
      const {
        topLeft: { x: d, y: p },
        topRight: { x: v, y: b },
        bottomLeft: { x: $, y },
        bottomRight: { x: _, y: P }
      } = u.position, w = Math.min(d, v, $, _), M = Math.min(p, b, y, P), A = Math.max(d, v, $, _), E = Math.max(p, b, y, P);
      return {
        boundingBox: new DOMRectReadOnly(w, M, A - w, E - M),
        rawValue: u.text,
        format: Wo(u.format),
        cornerPoints: [
          {
            x: d,
            y: p
          },
          {
            x: v,
            y: b
          },
          {
            x: _,
            y: P
          },
          {
            x: $,
            y
          }
        ]
      };
    });
  }
}
et = /* @__PURE__ */ new WeakMap();
const Or = (n, i, o = "error") => {
  let u, d;
  const p = new Promise(
    (v, b) => {
      u = v, d = b, n.addEventListener(i, u), n.addEventListener(o, d);
    }
  );
  return p.finally(() => {
    n.removeEventListener(i, u), n.removeEventListener(o, d);
  }), p;
}, vr = (n) => new Promise((i) => setTimeout(i, n));
class Ho extends Error {
  constructor() {
    super("can't process cross-origin image"), this.name = "DropImageFetchError";
  }
}
class Mr extends Error {
  constructor() {
    super("this browser has no Stream API support"), this.name = "StreamApiNotSupportedError";
  }
}
class Lo extends Error {
  constructor() {
    super(
      "camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP."
    ), this.name = "InsecureContextError";
  }
}
class Vo extends Error {
  constructor() {
    super("Loading camera stream timed out after 3 seconds. If you are on iOS in PWA mode, this is a known issue (see https://github.com/gruhn/vue-qrcode-reader/issues/298)"), this.name = "StreamLoadTimeoutError";
  }
}
const zo = async (n, {
  detectHandler: i,
  locateHandler: o,
  minDelay: u
}) => {
  const d = new Pt({ formats: ["qr_code"] }), p = (v) => async (b) => {
    if (n.readyState > 1) {
      const { lastScanned: $, contentBefore: y, lastScanHadContent: _ } = v;
      if (b - $ < u)
        window.requestAnimationFrame(p(v));
      else {
        const P = await d.detect(n), w = P.some((E) => !y.includes(E.rawValue));
        w && i(P);
        const M = P.length > 0;
        M && o(P), !M && _ && o(P);
        const A = {
          lastScanned: b,
          lastScanHadContent: M,
          // It can happen that a QR code is constantly in view of the camera but 
          // maybe a scanned frame is a bit blurry and we detect nothing but in the 
          // next frame we detect the code again. We also want to avoid emitting 
          // a `detect` event in such a case. So we don't reset `contentBefore`, 
          // if we detect nothing, only if we detect something new.
          contentBefore: w ? P.map((E) => E.rawValue) : y
        };
        window.requestAnimationFrame(p(A));
      }
    }
  };
  p({
    lastScanned: performance.now(),
    contentBefore: [],
    lastScanHadContent: !1
  })(performance.now());
}, Go = async (n) => {
  if (n.startsWith("http") && n.includes(location.host) === !1)
    throw new Ho();
  const i = document.createElement("img");
  return i.src = n, await Or(i, "load"), i;
}, Ar = async (n) => await new Pt({
  formats: ["qr_code"]
}).detect(n), qo = async (n) => {
  const i = new Pt({
    formats: ["qr_code"]
  }), o = await Go(n);
  return await i.detect(o);
};
var Dr = {}, J = {};
Object.defineProperty(J, "__esModule", {
  value: !0
});
J.compactObject = kr;
J.deprecated = ei;
var Bo = J.detectBrowser = ti;
J.disableLog = Xo;
J.disableWarnings = Ko;
J.extractVersion = tt;
J.filterStats = ri;
J.log = Zo;
J.walkStats = rt;
J.wrapPeerConnectionEvent = Qo;
function No(n, i, o) {
  return i = Yo(i), i in n ? Object.defineProperty(n, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : n[i] = o, n;
}
function Yo(n) {
  var i = Jo(n, "string");
  return de(i) === "symbol" ? i : String(i);
}
function Jo(n, i) {
  if (de(n) !== "object" || n === null)
    return n;
  var o = n[Symbol.toPrimitive];
  if (o !== void 0) {
    var u = o.call(n, i || "default");
    if (de(u) !== "object")
      return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (i === "string" ? String : Number)(n);
}
function de(n) {
  "@babel/helpers - typeof";
  return de = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, de(n);
}
var Rr = !0, xr = !0;
function tt(n, i, o) {
  var u = n.match(i);
  return u && u.length >= o && parseInt(u[o], 10);
}
function Qo(n, i, o) {
  if (n.RTCPeerConnection) {
    var u = n.RTCPeerConnection.prototype, d = u.addEventListener;
    u.addEventListener = function(v, b) {
      if (v !== i)
        return d.apply(this, arguments);
      var $ = function(_) {
        var P = o(_);
        P && (b.handleEvent ? b.handleEvent(P) : b(P));
      };
      return this._eventMap = this._eventMap || {}, this._eventMap[i] || (this._eventMap[i] = /* @__PURE__ */ new Map()), this._eventMap[i].set(b, $), d.apply(this, [v, $]);
    };
    var p = u.removeEventListener;
    u.removeEventListener = function(v, b) {
      if (v !== i || !this._eventMap || !this._eventMap[i])
        return p.apply(this, arguments);
      if (!this._eventMap[i].has(b))
        return p.apply(this, arguments);
      var $ = this._eventMap[i].get(b);
      return this._eventMap[i].delete(b), this._eventMap[i].size === 0 && delete this._eventMap[i], Object.keys(this._eventMap).length === 0 && delete this._eventMap, p.apply(this, [v, $]);
    }, Object.defineProperty(u, "on" + i, {
      get: function() {
        return this["_on" + i];
      },
      set: function(b) {
        this["_on" + i] && (this.removeEventListener(i, this["_on" + i]), delete this["_on" + i]), b && this.addEventListener(i, this["_on" + i] = b);
      },
      enumerable: !0,
      configurable: !0
    });
  }
}
function Xo(n) {
  return typeof n != "boolean" ? new Error("Argument type: " + de(n) + ". Please use a boolean.") : (Rr = n, n ? "adapter.js logging disabled" : "adapter.js logging enabled");
}
function Ko(n) {
  return typeof n != "boolean" ? new Error("Argument type: " + de(n) + ". Please use a boolean.") : (xr = !n, "adapter.js deprecation warnings " + (n ? "disabled" : "enabled"));
}
function Zo() {
  if ((typeof window > "u" ? "undefined" : de(window)) === "object") {
    if (Rr)
      return;
    typeof console < "u" && typeof console.log == "function" && console.log.apply(console, arguments);
  }
}
function ei(n, i) {
  xr && console.warn(n + " is deprecated, please use " + i + " instead.");
}
function ti(n) {
  var i = {
    browser: null,
    version: null
  };
  if (typeof n > "u" || !n.navigator)
    return i.browser = "Not a browser.", i;
  var o = n.navigator;
  if (o.mozGetUserMedia)
    i.browser = "firefox", i.version = tt(o.userAgent, /Firefox\/(\d+)\./, 1);
  else if (o.webkitGetUserMedia || n.isSecureContext === !1 && n.webkitRTCPeerConnection)
    i.browser = "chrome", i.version = tt(o.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
  else if (n.RTCPeerConnection && o.userAgent.match(/AppleWebKit\/(\d+)\./))
    i.browser = "safari", i.version = tt(o.userAgent, /AppleWebKit\/(\d+)\./, 1), i.supportsUnifiedPlan = n.RTCRtpTransceiver && "currentDirection" in n.RTCRtpTransceiver.prototype;
  else
    return i.browser = "Not a supported browser.", i;
  return i;
}
function mr(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function kr(n) {
  return mr(n) ? Object.keys(n).reduce(function(i, o) {
    var u = mr(n[o]), d = u ? kr(n[o]) : n[o], p = u && !Object.keys(d).length;
    return d === void 0 || p ? i : Object.assign(i, No({}, o, d));
  }, {}) : n;
}
function rt(n, i, o) {
  !i || o.has(i.id) || (o.set(i.id, i), Object.keys(i).forEach(function(u) {
    u.endsWith("Id") ? rt(n, n.get(i[u]), o) : u.endsWith("Ids") && i[u].forEach(function(d) {
      rt(n, n.get(d), o);
    });
  }));
}
function ri(n, i, o) {
  var u = o ? "outbound-rtp" : "inbound-rtp", d = /* @__PURE__ */ new Map();
  if (i === null)
    return d;
  var p = [];
  return n.forEach(function(v) {
    v.type === "track" && v.trackIdentifier === i.id && p.push(v);
  }), p.forEach(function(v) {
    n.forEach(function(b) {
      b.type === u && b.trackId === v.id && rt(n, b, d);
    });
  }), d;
}
Object.defineProperty(Dr, "__esModule", {
  value: !0
});
var ni = Dr.shimGetUserMedia = ii, ai = oi(J);
function Fr(n) {
  if (typeof WeakMap != "function")
    return null;
  var i = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
  return (Fr = function(d) {
    return d ? o : i;
  })(n);
}
function oi(n, i) {
  if (!i && n && n.__esModule)
    return n;
  if (n === null || le(n) !== "object" && typeof n != "function")
    return { default: n };
  var o = Fr(i);
  if (o && o.has(n))
    return o.get(n);
  var u = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var p in n)
    if (p !== "default" && Object.prototype.hasOwnProperty.call(n, p)) {
      var v = d ? Object.getOwnPropertyDescriptor(n, p) : null;
      v && (v.get || v.set) ? Object.defineProperty(u, p, v) : u[p] = n[p];
    }
  return u.default = n, o && o.set(n, u), u;
}
function le(n) {
  "@babel/helpers - typeof";
  return le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, le(n);
}
var yr = ai.log;
function ii(n, i) {
  var o = n && n.navigator;
  if (o.mediaDevices) {
    var u = function(y) {
      if (le(y) !== "object" || y.mandatory || y.optional)
        return y;
      var _ = {};
      return Object.keys(y).forEach(function(P) {
        if (!(P === "require" || P === "advanced" || P === "mediaSource")) {
          var w = le(y[P]) === "object" ? y[P] : {
            ideal: y[P]
          };
          w.exact !== void 0 && typeof w.exact == "number" && (w.min = w.max = w.exact);
          var M = function(G, j) {
            return G ? G + j.charAt(0).toUpperCase() + j.slice(1) : j === "deviceId" ? "sourceId" : j;
          };
          if (w.ideal !== void 0) {
            _.optional = _.optional || [];
            var A = {};
            typeof w.ideal == "number" ? (A[M("min", P)] = w.ideal, _.optional.push(A), A = {}, A[M("max", P)] = w.ideal, _.optional.push(A)) : (A[M("", P)] = w.ideal, _.optional.push(A));
          }
          w.exact !== void 0 && typeof w.exact != "number" ? (_.mandatory = _.mandatory || {}, _.mandatory[M("", P)] = w.exact) : ["min", "max"].forEach(function(E) {
            w[E] !== void 0 && (_.mandatory = _.mandatory || {}, _.mandatory[M(E, P)] = w[E]);
          });
        }
      }), y.advanced && (_.optional = (_.optional || []).concat(y.advanced)), _;
    }, d = function(y, _) {
      if (i.version >= 61)
        return _(y);
      if (y = JSON.parse(JSON.stringify(y)), y && le(y.audio) === "object") {
        var P = function(G, j, H) {
          j in G && !(H in G) && (G[H] = G[j], delete G[j]);
        };
        y = JSON.parse(JSON.stringify(y)), P(y.audio, "autoGainControl", "googAutoGainControl"), P(y.audio, "noiseSuppression", "googNoiseSuppression"), y.audio = u(y.audio);
      }
      if (y && le(y.video) === "object") {
        var w = y.video.facingMode;
        w = w && (le(w) === "object" ? w : {
          ideal: w
        });
        var M = i.version < 66;
        if (w && (w.exact === "user" || w.exact === "environment" || w.ideal === "user" || w.ideal === "environment") && !(o.mediaDevices.getSupportedConstraints && o.mediaDevices.getSupportedConstraints().facingMode && !M)) {
          delete y.video.facingMode;
          var A;
          if (w.exact === "environment" || w.ideal === "environment" ? A = ["back", "rear"] : (w.exact === "user" || w.ideal === "user") && (A = ["front"]), A)
            return o.mediaDevices.enumerateDevices().then(function(E) {
              E = E.filter(function(j) {
                return j.kind === "videoinput";
              });
              var G = E.find(function(j) {
                return A.some(function(H) {
                  return j.label.toLowerCase().includes(H);
                });
              });
              return !G && E.length && A.includes("back") && (G = E[E.length - 1]), G && (y.video.deviceId = w.exact ? {
                exact: G.deviceId
              } : {
                ideal: G.deviceId
              }), y.video = u(y.video), yr("chrome: " + JSON.stringify(y)), _(y);
            });
        }
        y.video = u(y.video);
      }
      return yr("chrome: " + JSON.stringify(y)), _(y);
    }, p = function(y) {
      return i.version >= 64 ? y : {
        name: {
          PermissionDeniedError: "NotAllowedError",
          PermissionDismissedError: "NotAllowedError",
          InvalidStateError: "NotAllowedError",
          DevicesNotFoundError: "NotFoundError",
          ConstraintNotSatisfiedError: "OverconstrainedError",
          TrackStartError: "NotReadableError",
          MediaDeviceFailedDueToShutdown: "NotAllowedError",
          MediaDeviceKillSwitchOn: "NotAllowedError",
          TabCaptureError: "AbortError",
          ScreenCaptureError: "AbortError",
          DeviceCaptureError: "AbortError"
        }[y.name] || y.name,
        message: y.message,
        constraint: y.constraint || y.constraintName,
        toString: function() {
          return this.name + (this.message && ": ") + this.message;
        }
      };
    }, v = function(y, _, P) {
      d(y, function(w) {
        o.webkitGetUserMedia(w, _, function(M) {
          P && P(p(M));
        });
      });
    };
    if (o.getUserMedia = v.bind(o), o.mediaDevices.getUserMedia) {
      var b = o.mediaDevices.getUserMedia.bind(o.mediaDevices);
      o.mediaDevices.getUserMedia = function($) {
        return d($, function(y) {
          return b(y).then(function(_) {
            if (y.audio && !_.getAudioTracks().length || y.video && !_.getVideoTracks().length)
              throw _.getTracks().forEach(function(P) {
                P.stop();
              }), new DOMException("", "NotFoundError");
            return _;
          }, function(_) {
            return Promise.reject(p(_));
          });
        });
      };
    }
  }
}
var Ur = {};
Object.defineProperty(Ur, "__esModule", {
  value: !0
});
var si = Ur.shimGetUserMedia = li, ci = ui(J);
function jr(n) {
  if (typeof WeakMap != "function")
    return null;
  var i = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
  return (jr = function(d) {
    return d ? o : i;
  })(n);
}
function ui(n, i) {
  if (!i && n && n.__esModule)
    return n;
  if (n === null || Se(n) !== "object" && typeof n != "function")
    return { default: n };
  var o = jr(i);
  if (o && o.has(n))
    return o.get(n);
  var u = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var p in n)
    if (p !== "default" && Object.prototype.hasOwnProperty.call(n, p)) {
      var v = d ? Object.getOwnPropertyDescriptor(n, p) : null;
      v && (v.get || v.set) ? Object.defineProperty(u, p, v) : u[p] = n[p];
    }
  return u.default = n, o && o.set(n, u), u;
}
function Se(n) {
  "@babel/helpers - typeof";
  return Se = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, Se(n);
}
function li(n, i) {
  var o = n && n.navigator, u = n && n.MediaStreamTrack;
  if (o.getUserMedia = function($, y, _) {
    ci.deprecated("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia"), o.mediaDevices.getUserMedia($).then(y, _);
  }, !(i.version > 55 && "autoGainControl" in o.mediaDevices.getSupportedConstraints())) {
    var d = function(y, _, P) {
      _ in y && !(P in y) && (y[P] = y[_], delete y[_]);
    }, p = o.mediaDevices.getUserMedia.bind(o.mediaDevices);
    if (o.mediaDevices.getUserMedia = function($) {
      return Se($) === "object" && Se($.audio) === "object" && ($ = JSON.parse(JSON.stringify($)), d($.audio, "autoGainControl", "mozAutoGainControl"), d($.audio, "noiseSuppression", "mozNoiseSuppression")), p($);
    }, u && u.prototype.getSettings) {
      var v = u.prototype.getSettings;
      u.prototype.getSettings = function() {
        var $ = v.apply(this, arguments);
        return d($, "mozAutoGainControl", "autoGainControl"), d($, "mozNoiseSuppression", "noiseSuppression"), $;
      };
    }
    if (u && u.prototype.applyConstraints) {
      var b = u.prototype.applyConstraints;
      u.prototype.applyConstraints = function($) {
        return this.kind === "audio" && Se($) === "object" && ($ = JSON.parse(JSON.stringify($)), d($, "autoGainControl", "mozAutoGainControl"), d($, "noiseSuppression", "mozNoiseSuppression")), b.apply(this, [$]);
      };
    }
  }
}
var Z = {};
Object.defineProperty(Z, "__esModule", {
  value: !0
});
Z.shimAudioContext = bi;
Z.shimCallbacksAPI = vi;
Z.shimConstraints = Hr;
Z.shimCreateOfferLegacy = wi;
var fi = Z.shimGetUserMedia = mi;
Z.shimLocalStreamsAPI = pi;
Z.shimRTCIceServerUrls = yi;
Z.shimRemoteStreamsAPI = hi;
Z.shimTrackEventTransceiver = gi;
var Ir = di(J);
function Wr(n) {
  if (typeof WeakMap != "function")
    return null;
  var i = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
  return (Wr = function(d) {
    return d ? o : i;
  })(n);
}
function di(n, i) {
  if (!i && n && n.__esModule)
    return n;
  if (n === null || pe(n) !== "object" && typeof n != "function")
    return { default: n };
  var o = Wr(i);
  if (o && o.has(n))
    return o.get(n);
  var u = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var p in n)
    if (p !== "default" && Object.prototype.hasOwnProperty.call(n, p)) {
      var v = d ? Object.getOwnPropertyDescriptor(n, p) : null;
      v && (v.get || v.set) ? Object.defineProperty(u, p, v) : u[p] = n[p];
    }
  return u.default = n, o && o.set(n, u), u;
}
function pe(n) {
  "@babel/helpers - typeof";
  return pe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, pe(n);
}
function pi(n) {
  if (!(pe(n) !== "object" || !n.RTCPeerConnection)) {
    if ("getLocalStreams" in n.RTCPeerConnection.prototype || (n.RTCPeerConnection.prototype.getLocalStreams = function() {
      return this._localStreams || (this._localStreams = []), this._localStreams;
    }), !("addStream" in n.RTCPeerConnection.prototype)) {
      var i = n.RTCPeerConnection.prototype.addTrack;
      n.RTCPeerConnection.prototype.addStream = function(u) {
        var d = this;
        this._localStreams || (this._localStreams = []), this._localStreams.includes(u) || this._localStreams.push(u), u.getAudioTracks().forEach(function(p) {
          return i.call(d, p, u);
        }), u.getVideoTracks().forEach(function(p) {
          return i.call(d, p, u);
        });
      }, n.RTCPeerConnection.prototype.addTrack = function(u) {
        for (var d = this, p = arguments.length, v = new Array(p > 1 ? p - 1 : 0), b = 1; b < p; b++)
          v[b - 1] = arguments[b];
        return v && v.forEach(function($) {
          d._localStreams ? d._localStreams.includes($) || d._localStreams.push($) : d._localStreams = [$];
        }), i.apply(this, arguments);
      };
    }
    "removeStream" in n.RTCPeerConnection.prototype || (n.RTCPeerConnection.prototype.removeStream = function(u) {
      var d = this;
      this._localStreams || (this._localStreams = []);
      var p = this._localStreams.indexOf(u);
      if (p !== -1) {
        this._localStreams.splice(p, 1);
        var v = u.getTracks();
        this.getSenders().forEach(function(b) {
          v.includes(b.track) && d.removeTrack(b);
        });
      }
    });
  }
}
function hi(n) {
  if (!(pe(n) !== "object" || !n.RTCPeerConnection) && ("getRemoteStreams" in n.RTCPeerConnection.prototype || (n.RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this._remoteStreams ? this._remoteStreams : [];
  }), !("onaddstream" in n.RTCPeerConnection.prototype))) {
    Object.defineProperty(n.RTCPeerConnection.prototype, "onaddstream", {
      get: function() {
        return this._onaddstream;
      },
      set: function(u) {
        var d = this;
        this._onaddstream && (this.removeEventListener("addstream", this._onaddstream), this.removeEventListener("track", this._onaddstreampoly)), this.addEventListener("addstream", this._onaddstream = u), this.addEventListener("track", this._onaddstreampoly = function(p) {
          p.streams.forEach(function(v) {
            if (d._remoteStreams || (d._remoteStreams = []), !d._remoteStreams.includes(v)) {
              d._remoteStreams.push(v);
              var b = new Event("addstream");
              b.stream = v, d.dispatchEvent(b);
            }
          });
        });
      }
    });
    var i = n.RTCPeerConnection.prototype.setRemoteDescription;
    n.RTCPeerConnection.prototype.setRemoteDescription = function() {
      var u = this;
      return this._onaddstreampoly || this.addEventListener("track", this._onaddstreampoly = function(d) {
        d.streams.forEach(function(p) {
          if (u._remoteStreams || (u._remoteStreams = []), !(u._remoteStreams.indexOf(p) >= 0)) {
            u._remoteStreams.push(p);
            var v = new Event("addstream");
            v.stream = p, u.dispatchEvent(v);
          }
        });
      }), i.apply(u, arguments);
    };
  }
}
function vi(n) {
  if (!(pe(n) !== "object" || !n.RTCPeerConnection)) {
    var i = n.RTCPeerConnection.prototype, o = i.createOffer, u = i.createAnswer, d = i.setLocalDescription, p = i.setRemoteDescription, v = i.addIceCandidate;
    i.createOffer = function(y, _) {
      var P = arguments.length >= 2 ? arguments[2] : arguments[0], w = o.apply(this, [P]);
      return _ ? (w.then(y, _), Promise.resolve()) : w;
    }, i.createAnswer = function(y, _) {
      var P = arguments.length >= 2 ? arguments[2] : arguments[0], w = u.apply(this, [P]);
      return _ ? (w.then(y, _), Promise.resolve()) : w;
    };
    var b = function(y, _, P) {
      var w = d.apply(this, [y]);
      return P ? (w.then(_, P), Promise.resolve()) : w;
    };
    i.setLocalDescription = b, b = function(y, _, P) {
      var w = p.apply(this, [y]);
      return P ? (w.then(_, P), Promise.resolve()) : w;
    }, i.setRemoteDescription = b, b = function(y, _, P) {
      var w = v.apply(this, [y]);
      return P ? (w.then(_, P), Promise.resolve()) : w;
    }, i.addIceCandidate = b;
  }
}
function mi(n) {
  var i = n && n.navigator;
  if (i.mediaDevices && i.mediaDevices.getUserMedia) {
    var o = i.mediaDevices, u = o.getUserMedia.bind(o);
    i.mediaDevices.getUserMedia = function(d) {
      return u(Hr(d));
    };
  }
  !i.getUserMedia && i.mediaDevices && i.mediaDevices.getUserMedia && (i.getUserMedia = function(p, v, b) {
    i.mediaDevices.getUserMedia(p).then(v, b);
  }.bind(i));
}
function Hr(n) {
  return n && n.video !== void 0 ? Object.assign({}, n, {
    video: Ir.compactObject(n.video)
  }) : n;
}
function yi(n) {
  if (n.RTCPeerConnection) {
    var i = n.RTCPeerConnection;
    n.RTCPeerConnection = function(u, d) {
      if (u && u.iceServers) {
        for (var p = [], v = 0; v < u.iceServers.length; v++) {
          var b = u.iceServers[v];
          b.urls === void 0 && b.url ? (Ir.deprecated("RTCIceServer.url", "RTCIceServer.urls"), b = JSON.parse(JSON.stringify(b)), b.urls = b.url, delete b.url, p.push(b)) : p.push(u.iceServers[v]);
        }
        u.iceServers = p;
      }
      return new i(u, d);
    }, n.RTCPeerConnection.prototype = i.prototype, "generateCertificate" in i && Object.defineProperty(n.RTCPeerConnection, "generateCertificate", {
      get: function() {
        return i.generateCertificate;
      }
    });
  }
}
function gi(n) {
  pe(n) === "object" && n.RTCTrackEvent && "receiver" in n.RTCTrackEvent.prototype && !("transceiver" in n.RTCTrackEvent.prototype) && Object.defineProperty(n.RTCTrackEvent.prototype, "transceiver", {
    get: function() {
      return {
        receiver: this.receiver
      };
    }
  });
}
function wi(n) {
  var i = n.RTCPeerConnection.prototype.createOffer;
  n.RTCPeerConnection.prototype.createOffer = function(u) {
    if (u) {
      typeof u.offerToReceiveAudio < "u" && (u.offerToReceiveAudio = !!u.offerToReceiveAudio);
      var d = this.getTransceivers().find(function(v) {
        return v.receiver.track.kind === "audio";
      });
      u.offerToReceiveAudio === !1 && d ? d.direction === "sendrecv" ? d.setDirection ? d.setDirection("sendonly") : d.direction = "sendonly" : d.direction === "recvonly" && (d.setDirection ? d.setDirection("inactive") : d.direction = "inactive") : u.offerToReceiveAudio === !0 && !d && this.addTransceiver("audio", {
        direction: "recvonly"
      }), typeof u.offerToReceiveVideo < "u" && (u.offerToReceiveVideo = !!u.offerToReceiveVideo);
      var p = this.getTransceivers().find(function(v) {
        return v.receiver.track.kind === "video";
      });
      u.offerToReceiveVideo === !1 && p ? p.direction === "sendrecv" ? p.setDirection ? p.setDirection("sendonly") : p.direction = "sendonly" : p.direction === "recvonly" && (p.setDirection ? p.setDirection("inactive") : p.direction = "inactive") : u.offerToReceiveVideo === !0 && !p && this.addTransceiver("video", {
        direction: "recvonly"
      });
    }
    return i.apply(this, arguments);
  };
}
function bi(n) {
  pe(n) !== "object" || n.AudioContext || (n.AudioContext = n.webkitAudioContext);
}
const Ci = (n) => {
  let i = !1, o;
  return (...u) => (i || (o = n(u), i = !0), o);
}, _i = Ci(() => {
  const n = Bo(window);
  switch (n.browser) {
    case "chrome":
      ni(window, n);
      break;
    case "firefox":
      si(window, n);
      break;
    case "safari":
      fi(window, n);
      break;
    default:
      throw new Mr();
  }
});
let ie = { isActive: !1 };
function Ct() {
  if (ie.isActive) {
    ie.videoEl.src = "", ie.videoEl.srcObject = null, ie.videoEl.load();
    for (const n of ie.stream.getTracks())
      ie.stream.removeTrack(n), n.stop();
    ie = { isActive: !1 };
  }
}
async function $i(n, { constraints: i, torch: o }) {
  var p, v;
  if (window.isSecureContext !== !0)
    throw new Lo();
  if (((p = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : p.getUserMedia) === void 0)
    throw new Mr();
  _i();
  const u = await navigator.mediaDevices.getUserMedia({
    audio: !1,
    video: i
  });
  if (n.srcObject !== void 0 ? n.srcObject = u : n.mozSrcObject !== void 0 ? n.mozSrcObject = u : window.URL.createObjectURL ? n.src = window.URL.createObjectURL(u) : window.webkitURL ? n.src = window.webkitURL.createObjectURL(u) : n.src = u.id, await Promise.race([
    Or(n, "loadeddata"),
    // On iOS devices in PWA mode, QrcodeStream works initially, but after
    // killing and restarting the PWA, all video elements fail to load camera 
    // streams and never emit the `loadeddata` event. Looks like this is 
    // related to a WebKit issue (see #298). No workarounds at the moment. 
    // To at least detect this situation, we throw an error if the event
    // has not been emitted after a 3 second timeout.
    vr(3e3).then(() => {
      throw new Vo();
    })
  ]), await vr(500), o) {
    const [b] = u.getVideoTracks();
    b.getCapabilities().torch ? b.applyConstraints({ advanced: [{ torch: !0 }] }) : console.warn("device does not support torch capability");
  }
  ie = { videoEl: n, stream: u, isActive: !0 };
  const [d] = ie.stream.getVideoTracks();
  return ((v = d == null ? void 0 : d.getCapabilities) == null ? void 0 : v.call(d)) ?? {};
}
const Si = { class: "qrcode-stream-wrapper" }, Pi = { class: "qrcode-stream-overlay" }, Ti = /* @__PURE__ */ _t({
  __name: "QrcodeStream",
  props: {
    constraints: {
      type: Object,
      default() {
        return { facingMode: "environment" };
      }
    },
    paused: {
      type: Boolean,
      default: !1
    },
    torch: {
      type: Boolean,
      default: !1
    },
    track: {
      type: Function
    }
  },
  emits: ["detect", "camera-on", "camera-off", "error"],
  setup(n, { emit: i }) {
    const o = n, u = xe(), d = xe(), p = xe(), v = xe(!1), b = xe(!1);
    po(() => {
      b.value = !0;
    }), ho(() => {
      Ct();
    });
    const $ = cr(() => ({
      torch: o.torch,
      constraints: o.constraints,
      shouldStream: b.value && !o.paused
    }));
    ur($, async (w) => {
      if (w.shouldStream)
        try {
          const M = await $i(p.value, w);
          b.value ? (v.value = !0, i("camera-on", M)) : Ct();
        } catch (M) {
          i("error", M);
        }
      else {
        const M = u.value, A = M.getContext("2d"), E = p.value;
        M.width = E.videoWidth, M.height = E.videoHeight, A == null || A.drawImage(E, 0, 0, E.videoWidth, E.videoHeight), Ct(), v.value = !1, i("camera-off");
      }
    }, { deep: !0 });
    const y = cr(() => $.value.shouldStream && v.value);
    ur(y, (w) => {
      if (w) {
        _(u.value), _(d.value);
        const M = () => o.track === void 0 ? 500 : 40;
        zo(p.value, {
          detectHandler: (A) => i("detect", A),
          locateHandler: P,
          minDelay: M()
        });
      }
    });
    const _ = (w) => {
      const M = w.getContext("2d");
      console.assert(
        M !== void 0,
        "tried to clear canvas with undefined 2D context"
      ), M.clearRect(0, 0, w.width, w.height);
    }, P = (w) => {
      const M = d.value, A = p.value;
      if (console.assert(
        M !== void 0 && A !== void 0,
        "onLocate handler called although component is not mounted"
      ), w.length === 0 || o.track === void 0)
        _(M);
      else {
        const E = A.offsetWidth, G = A.offsetHeight, j = A.videoWidth, H = A.videoHeight, ee = Math.max(E / j, G / H), he = j * ee, V = H * ee, L = he / j, ke = V / H, Fe = (E - he) / 2, Ue = (G - V) / 2, be = ({ x: se, y: K }) => ({
          x: Math.floor(se * L),
          y: Math.floor(K * ke)
        }), Pe = ({ x: se, y: K }) => ({
          x: Math.floor(se + Fe),
          y: Math.floor(K + Ue)
        }), je = w.map((se) => {
          const { boundingBox: K, cornerPoints: at } = se, { x: ot, y: it } = Pe(
            be({
              x: K.x,
              y: K.y
            })
          ), { x: st, y: te } = be({
            x: K.width,
            y: K.height
          });
          return {
            ...se,
            cornerPoints: at.map((ve) => Pe(be(ve))),
            boundingBox: DOMRectReadOnly.fromRect({ x: ot, y: it, width: st, height: te })
          };
        });
        M.width = A.offsetWidth, M.height = A.offsetHeight;
        const Ie = M.getContext("2d");
        o.track(je, Ie);
      }
    };
    return (w, M) => ($t(), St("div", Si, [
      Ke("video", {
        ref_key: "videoRef",
        ref: p,
        class: vo([{ "qrcode-stream-camera--hidden": !y.value }, "qrcode-stream-camera"]),
        autoplay: "",
        muted: "",
        playsinline: ""
      }, null, 2),
      mo(Ke("canvas", {
        ref_key: "pauseFrameRef",
        ref: u,
        class: "qrcode-stream-camera"
      }, null, 512), [
        [yo, !y.value]
      ]),
      Ke("canvas", {
        ref_key: "trackingLayerRef",
        ref: d,
        class: "qrcode-stream-overlay"
      }, null, 512),
      Ke("div", Pi, [
        gr(w.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
});
const Ei = (n, i) => {
  const o = n.__vccOpts || n;
  for (const [u, d] of i)
    o[u] = d;
  return o;
}, Oi = /* @__PURE__ */ Ei(Ti, [["__scopeId", "data-v-44e7ec8a"]]), Mi = /* @__PURE__ */ _t({
  __name: "QrcodeCapture",
  emits: ["detect"],
  setup(n, { emit: i }) {
    const o = async (d) => {
      const p = await await d;
      i("detect", p);
    }, u = (d) => {
      if (!(d.target instanceof HTMLInputElement) || !d.target.files)
        return;
      const p = [...Array.from(d.target.files)];
      for (const v of p.map(Ar))
        o(v);
    };
    return (d, p) => ($t(), St("input", {
      onChange: u,
      type: "file",
      name: "image",
      accept: "image/*",
      capture: "environment",
      multiple: ""
    }, null, 32));
  }
}), Ai = ["onDrop"], Di = /* @__PURE__ */ _t({
  __name: "QrcodeDropZone",
  emits: ["detect", "dragover", "error"],
  setup(n, { emit: i }) {
    const o = async (p) => {
      try {
        const v = await p;
        i("detect", v);
      } catch (v) {
        i("error", v);
      }
    }, u = (p) => {
      i("dragover", p);
    }, d = ({ dataTransfer: p }) => {
      if (!p)
        return;
      u(!1);
      const v = [...Array.from(p.files)], b = p.getData("text/uri-list");
      v.forEach(($) => {
        o(Ar($));
      }), b !== "" && o(qo(b));
    };
    return (p, v) => ($t(), St("div", {
      onDrop: Ze(d, ["prevent", "stop"]),
      onDragenter: v[0] || (v[0] = Ze((b) => u(!0), ["prevent", "stop"])),
      onDragleave: v[1] || (v[1] = Ze((b) => u(!1), ["prevent", "stop"])),
      onDragover: v[2] || (v[2] = Ze(() => {
      }, ["prevent", "stop"]))
    }, [
      gr(p.$slots, "default")
    ], 40, Ai));
  }
});
function Ri(n) {
  n.component("qrcode-stream", Oi), n.component("qrcode-capture", Mi), n.component("qrcode-drop-zone", Di);
}
const xi = { install: Ri };
let nt = null;
typeof window < "u" ? nt = window.Vue : typeof global < "u" && (nt = global.Vue);
nt && nt.use(xi);
export {
  Mi as QrcodeCapture,
  Di as QrcodeDropZone,
  Oi as QrcodeStream,
  xi as VueQrcodeReader,
  Ri as install,
  Fi as setZXingModuleOverrides
};
